import React, { useEffect, useState, useRef, useLayoutEffect, useMemo, useReducer, useCallback } from 'react';
import { loginToastReducer, loginToastInitState } from '@growth/shared-reducers';
import { shallow } from 'zustand/shallow';
import { useSendOtpStore, usePrefillLoginDetails, isMobileEncoded, clearSendOtpStore, useLoginUserStore, useSignupViaOTPStore, isNumberValid, INVALID_OTP_CODE, EXISTING_USER_STATUS_CODE, getUuidFromCookie, isEmailValid, isNameValid, useTruecallerLoginStore, useProfileUpdateStore, getTruecallerDeepLink, TRUECALLER_DEEPLINK_DATA } from '@growth/auth-helpers';
import { useAnalytics, AnalyticsContextProvider } from '@growth/use-analytics';
import styled, { keyframes, ThemeProvider } from 'styled-components';
import { createPortal } from 'react-dom';
import ConfirmDialog, { CONFIRM_CTA } from '@growth/confirm-dialog';
import { use100Vh } from '@growth/custom-hooks/use100Vh';
import { isAndroidClient, isIOSSafariBrowser } from '@growth/user-agents';
import { pdtPush } from '@growth/pdt-push';
import { create } from 'zustand';
import { createConfigStore, setData } from '@growth/config-store/browser';
import { textSizes, headingSizes } from '@growth/design-system';
import { useNetwork } from '@growth/custom-hooks/useNetwork';
import { CircularLoader } from '@growth/loader';
import { isOnClient } from '@growth/ssr-utils';
import { ToolTip } from '@growth/tooltip';
import { generateVid } from '@growth/visitor-id/browser';
import { docSessionStorage } from '@growth/browser-storage';
import { getEncryptedUuid } from '@growth/auth-utils';
import { defaultTheme } from '@growth/app-theme';
import WebAnalytics from '@growth/web-analytics';
import googleTagManager from '@growth/analytics-plugin-gtm';
import pdtAnalytics from '@growth/analytics-plugin-pdt';
import adobeAnalytics from '@growth/analytics-plugin-adobe';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

var _templateObject$9;
var AuthContainer$1 = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n\t.gr-cap-text {\n\t\ttext-transform: uppercase;\n\t}\n\n\t/* -- In case you need to add a gutter above/below an element -- */\n\t.gr-append-bottom3,\n\t.gr-appendBottom3 {\n\t\tmargin-bottom: 3px;\n\t}\n\n\t.gr-appendBottom20 {\n\t\tmargin-bottom: 20px;\n\t}\n\n\t.gr-appendBottom15 {\n\t\tmargin-bottom: 15px;\n\t}\n\n\t.gr-appendBottom25 {\n\t\tmargin-bottom: 25px;\n\t}\n\n\t.gr-appendBottom8 {\n\t\tmargin-bottom: 8px;\n\t}\n\n\t.gr-appendBottom10 {\n\t\tmargin-bottom: 10px;\n\t}\n\n\t.gr-append-bottom30 {\n\t\tmargin-bottom: 30px;\n\t}\n\n\t.gr-appendTop30 {\n\t\tmargin-top: 30px;\n\t}\n\n\t.gr-appendTop20 {\n\t\tmargin-top: 20px;\n\t}\n\n\t.gr-appendTop15 {\n\t\tmargin-top: 15px;\n\t}\n\n\t.gr-appendTop10 {\n\t\tmargin-top: 10px;\n\t}\n\n\t.gr-appendTop8 {\n\t\tmargin-top: 8px;\n\t}\n\n\t.gr-appendTop5 {\n\t\tmargin-top: 5px;\n\t}\n\n\t.gr-append-left5 {\n\t\tmargin-left: 5px;\n\t}\n\n\t.gr-append-left10 {\n\t\tmargin-left: 10px;\n\t}\n\n\t.gr-append-left20 {\n\t\tmargin-left: 20px;\n\t}\n\n\t.gr-append-left15 {\n\t\tmargin-left: 15px;\n\t}\n\n\t.gr-append-left6 {\n\t\tmargin-left: 6px;\n\t}\n\n\t.gr-append-left0 {\n\t\tmargin-left: 0 !important;\n\t}\n\n\t.gr-append-right5 {\n\t\tmargin-right: 5px;\n\t}\n\n\t.gr-appendRight10,\n\t.gr-append-right10 {\n\t\tmargin-right: 10px;\n\t}\n\n\t.gr-append-right15 {\n\t\tmargin-right: 15px;\n\t}\n\n\t.gr-append-right20,\n\t.gr-appendRight20 {\n\t\tmargin-right: 20px;\n\t}\n\n\t.gr-appendRight10 {\n\t\tmargin-right: 10px;\n\t}\n\n\t/* -- In case you need to add a gutter Left - Right the element -- */\n\n\t/* .gr-box-padding {\n    padding: 15px 20px;\n  }\n  */\n\n\t/* Icon via css */\n\ti::before,\n\ti::after {\n\t\tcontent: '';\n\t\tbox-sizing: border-box;\n\t}\n\n\t/* -- In case you need to add a size -- */\n\t.gr-font10 {\n\t\tfont-size: 10px;\n\t}\n\n\t.gr-font12 {\n\t\tfont-size: 12px;\n\t}\n\n\t.gr-font14 {\n\t\tfont-size: 14px;\n\t}\n\n\t.gr-font16 {\n\t\tfont-size: 16px;\n\t}\n\n\t.gr-font18 {\n\t\tfont-size: 18px;\n\t}\n\n\t.gr-font22 {\n\t\tfont-size: 22px;\n\t}\n\n\t.gr-font24 {\n\t\tfont-size: 24px;\n\t}\n\n\t/* -- Font Weights -- */\n\t.gr-light {\n\t\tfont-weight: 300;\n\t}\n\n\t.gr-bold {\n\t\tfont-weight: 900;\n\t}\n\n\t/* -- In case you need to add a Font Family -- */\n\t.gr-quicksand,\n\t.gr-quickSand {\n\t}\n\n\t.gr-quickSandRegular {\n\t\tfont-weight: 400;\n\t}\n\n\t/* -- In case you need to add a Flex -- */\n\t.gr-make-flex {\n\t\tdisplay: flex;\n\t}\n\n\t.gr-make-flex.column {\n\t\tflex-direction: column;\n\t}\n\n\t.gr-make-flex.row {\n\t\tflex-direction: row;\n\t}\n\n\t.gr-make-flex.hrtl-center {\n\t\talign-items: center;\n\t}\n\n\t.gr-make-flex.wrap {\n\t\tflex-wrap: wrap;\n\t}\n\n\t.gr-flex-one,\n\t.gr-flexOne {\n\t\tflex: 1 !important;\n\t}\n\n\t.gr-noshrink {\n\t\tflex-shrink: 0;\n\t}\n\n\t.gr-flex-wrap {\n\t\tflex-wrap: wrap;\n\t}\n\n\t/* -- In case you need to change cursor type -- */\n\t/*\n  .gr-cursor-pointer {\n    cursor: pointer;\n  }\n  */\n\t/* -- In case you need to hide element -- */\n\t/*\n  .gr-hide {\n    display: none;\n  }\n  */\n\t.gr-helveticaBold {\n\t\tfont-weight: 500;\n\t}\n\n\t.gr-helvetica {\n\t}\n\n\t.gr-color333 {\n\t\tcolor: #333 !important;\n\t}\n\n\t.gr-color666 {\n\t\tcolor: #666 !important;\n\t}\n\n\t.gr-quickSandBold {\n\t\tfont-weight: 500;\n\t}\n\n\t.happy-gi-header a {\n\t\ttext-decoration: none !important;\n\t}\n\n\t.gr-lineHight18 {\n\t\tline-height: 18px !important;\n\t}\n\n\t.gr-lineHight20 {\n\t\tline-height: 20px;\n\t}\n\n\t.gr-pointer {\n\t\tcursor: pointer;\n\t}\n\n\t.gr-redText {\n\t\tcolor: #e53442;\n\t}\n\n\t.gr-blackText {\n\t\tcolor: #000;\n\t}\n\n\t.gr-textCenter {\n\t\ttext-align: center;\n\t}\n\n\t.gr-vertical-bottom {\n\t\tvertical-align: bottom;\n\t}\n\n\t.btn-hyperlink {\n\t\tcolor: #008cff !important;\n\t\tcursor: pointer;\n\t\tborder: 0;\n\t\tbackground-color: transparent;\n\t\ttext-decoration: none;\n\t}\n\n\t.btn-hyperlink:hover {\n\t\tcolor: #008cff;\n\t\ttext-decoration: none;\n\t}\n\n\t.gr-perfectCenter {\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t}\n\n\t.gr-lightGreenText {\n\t\tcolor: #00962d;\n\t}\n\t/*==================\n    Landing Common CSS\n=====================*/\n\t.logSprite {\n\t\tbackground: url(https://gos3.ibcdn.com/sprite-1620307422.png) no-repeat;\n\t\tdisplay: inline-block;\n\t\tbackground-size: 300px 300px;\n\t\tfont-size: 0px;\n\t\tflex-shrink: 0;\n\t}\n\t.logSprite.icGo {\n\t\twidth: 37px;\n\t\theight: 37px;\n\t\tbackground-position: -9px -8px;\n\t}\n\t.logSprite.icClose {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tbackground-position: -180px -8px;\n\t\tcursor: pointer;\n\t}\n\t.logSprite.icSuccessBig {\n\t\twidth: 41px;\n\t\theight: 40px;\n\t\tbackground-position: -60px -11px;\n\t}\n\t.logSprite.icSuccessSmall {\n\t\twidth: 19px;\n\t\theight: 18px;\n\t\tbackground-position: -132px -33px;\n\t}\n\t.logSprite.icShowPassword {\n\t\twidth: 17px;\n\t\theight: 15px;\n\t\tbackground-position: -105px -9px;\n\t\tcursor: pointer;\n\t}\n\t.logSprite.icSms {\n\t\twidth: 13px;\n\t\theight: 12px;\n\t\tbackground-position: -110px -39px;\n\t}\n\t.logSprite.icWhatsapp {\n\t\twidth: 13px;\n\t\theight: 12px;\n\t\tbackground-position: -157px -11px;\n\t}\n\t.logSprite.icInfoPink {\n\t\twidth: 18px;\n\t\theight: 19px;\n\t\tbackground-position: -131px -9px;\n\t\tcursor: pointer;\n\t}\n\t.logSprite.icEdit {\n\t\twidth: 17px;\n\t\theight: 17px;\n\t\tbackground-position: -157px -34px;\n\t\tcursor: pointer;\n\t}\n\t.logSprite.icOrangeTick {\n\t\twidth: 23px;\n\t\theight: 23px;\n\t\tbackground-position: -179px -29px;\n\t\tcursor: pointer;\n\t}\n\n\t/*==================\n      Loading shimmer\n  =====================*/\n\n\t.ldrShimmer {\n\t\tanimation-duration: 1.5s;\n\t\tanimation-fill-mode: forwards;\n\t\tanimation-iteration-count: infinite;\n\t\tanimation-name: shimmer;\n\t\tanimation-timing-function: linear;\n\t\tbackground: linear-gradient(to right, #ebeff2 8%, #f9fafb 18%, #ebeff2 33%);\n\t\tbackground-size: 800px 104px;\n\t\tposition: relative;\n\t}\n\n\t@-webkit-keyframes shimmer {\n\t\t0% {\n\t\t\tbackground-position: -468px 0;\n\t\t}\n\t\t100% {\n\t\t\tbackground-position: 468px 0;\n\t\t}\n\t}\n\n\t@-moz-keyframes shimmer {\n\t\t0% {\n\t\t\tbackground-position: -468px 0;\n\t\t}\n\t\t100% {\n\t\t\tbackground-position: 468px 0;\n\t\t}\n\t}\n\n\t.gr-bodyFixed {\n\t\toverflow: hidden;\n\t}\n\t.loginCont {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: space-between;\n\t\tposition: relative;\n\t}\n\t.loginCont__inputwrap {\n\t\theight: 56px;\n\t\tborder-radius: 4px;\n\t\tborder: solid 2px #016eff;\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t}\n\t.loginCont__inputwrap.invalid {\n\t\tborder-color: #e53442;\n\t}\n\t.loginCont__inputwrap.valid {\n\t\tborder-color: #00962d;\n\t}\n\t.loginCont__code {\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #c2c2c2;\n\t\tdisplay: inline-flex;\n\t\tpadding: 0 5px 0 20px;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t}\n\t.loginCont__label {\n\t\tdisplay: inline-flex;\n\t\tposition: absolute;\n\t\tleft: 11px;\n\t\ttop: -11px;\n\t\tbackground-color: #fff;\n\t\tpadding: 3px 8px;\n\t\tfont-size: 12px;\n\t\tcolor: #016eff;\n\t}\n\t.loginCont__inputwrap.invalid .loginCont__label {\n\t\tcolor: #e53442;\n\t}\n\t.loginCont__inputwrap.valid .loginCont__label {\n\t\tcolor: #00962d;\n\t}\n\t.loginCont__input {\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #4f525a;\n\t\tpadding-left: 5px;\n\t\tborder-radius: 0 4px 4px 0;\n\t}\n\t.loginCont__btn {\n\t\twidth: 100%;\n\t\theight: 47px;\n\t\tpadding: 13px 118px 13px 116px;\n\t\tmargin-top: 22px;\n\t\tborder-radius: 8px;\n\t\tbackground-color: #ff6d38;\n\t\tcolor: #fff;\n\t\toutline: 0;\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\tfont-size: 14px;\n\t\tfont-weight: 500;\n\n\t\t-webkit-appearance: none;\n\t}\n\t.loginCont__btn.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n\n\t.loginCont__tnc-safari {\n\t\tmargin-bottom: 50px !important;\n\t}\n\n\t.loginCont__tnc {\n\t\ttext-align: center;\n\t\tmargin-top: 22px;\n\t}\n\n\t.loginCont__tnc p {\n\t\tline-height: 18px !important;\n\t\tfont-size: 12px;\n\t}\n\t.loginCont__tnc a {\n\t\tcursor: pointer;\n\t}\n\t.loginCont__info {\n\t\tposition: absolute;\n\t\tright: 20px;\n\t\ttop: 17px;\n\t}\n\t.loginCont__inputPassword {\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\tfont-size: 16px;\n\t\tfont-weight: 500;\n\n\t\tcolor: #4f525a;\n\t\tpadding-left: 20px;\n\t\tborder-radius: 4px;\n\t}\n"])));

var AuthPortal = function AuthPortal(_ref) {
  var children = _ref.children;
  var modalRoot = document.getElementById('bottom-sheet-root');
  if (!modalRoot) {
    modalRoot = document.createElement('div');
    modalRoot.setAttribute('id', 'bottom-sheet-root');
    document.body.appendChild(modalRoot);
  }
  var modalElement = document.createElement('div');
  useEffect(function () {
    var _modalRoot;
    (_modalRoot = modalRoot) == null || _modalRoot.appendChild(modalElement);
    return function () {
      var _modalRoot2;
      (_modalRoot2 = modalRoot) == null || _modalRoot2.removeChild(modalElement);
    };
  }, []);
  return /*#__PURE__*/createPortal(children, modalElement);
};

var _templateObject$8, _templateObject2$6;
var BtmSheet = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n\toverscroll-behavior: none;\n\ttouch-action: none;\n\tuser-select: none;\n\tmax-height: ", ";\n\t/* --100vh set from js */\n\tborder-radius: ", ";\n\ttop: unset !important;\n\tmin-height: unset !important;\n\twidth: 100%;\n\theight: ", ";\n\tbackground-color: #fff;\n\tposition: fixed;\n\tleft: 0;\n\tbottom: 0;\n\tz-index: 1025;\n\toverflow-y: visible;\n\n\t.stepCompactHeight {\n\t\theight: auto !important;\n\t}\n\n\t.btmSheet__animate {\n\t\tanimation: btmSheet_slideUp1 0.3s ease-in-out forwards;\n\t}\n\n\t.btmSheet__close {\n\t\tmargin-left: auto;\n\t\tflex-shrink: 0;\n\t}\n\n\t@keyframes btmSheet_slideUp1 {\n\t\t0% {\n\t\t\ttransform: translateY(100%);\n\t\t}\n\n\t\t100% {\n\t\t\ttransform: translateY(0px);\n\t\t}\n\t}\n\n\t@media (orientation: landscape) and (min-device-width: 600px) {\n\t\t.btmSheet {\n\t\t\tmax-width: 600px;\n\t\t\tright: 0;\n\t\t\tmargin: 0 auto;\n\t\t}\n\t}\n"])), function (props) {
  return props.isFullPage ? null : 'calc(var(--100vh) - 36px)';
}, function (props) {
  return props.isFullPage ? 'none' : '16px 16px 0 0';
}, function (props) {
  return props.isFullPage ? '100%' : 'auto';
});
var BtmSheetBackDrop = styled.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: rgba(0, 0, 0, 0.5);\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tz-index: 1024;\n\ttouch-action: none;\n"])));

var BottomSheet = function BottomSheet(_ref) {
  var closeBottomSheet = _ref.closeBottomSheet,
    children = _ref.children,
    _ref$isFullPage = _ref.isFullPage,
    isFullPage = _ref$isFullPage === void 0 ? false : _ref$isFullPage,
    _ref$customClass = _ref.customClass,
    customClass = _ref$customClass === void 0 ? '' : _ref$customClass;
  useEffect(function () {
    var _document$querySelect;
    (_document$querySelect = document.querySelector("body")) == null || _document$querySelect.classList.add('gr-bodyFixed');
    return function () {
      var _document$querySelect2;
      (_document$querySelect2 = document.querySelector("body")) == null || _document$querySelect2.classList.remove('gr-bodyFixed');
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BtmSheetBackDrop, {
    className: "btmSheet__backdrop",
    onClick: closeBottomSheet || null,
    role: "presentation"
  }), /*#__PURE__*/React.createElement(BtmSheet, {
    className: "btmSheet btmSheet__animate " + customClass,
    isFullPage: isFullPage
  }, children));
};

var AUTH_FLOW_STEPS = {
  STEP_MOBILE: 'mobile',
  STEP_OTP: 'otp',
  STEP_PASSWORD: 'pwd',
  STEP_POST_AUTH: 'postlogin',
  STEP_TRUECALLER: 'truecallerLogin'
};
var LOGIN_TYPE = {
  otp: 'otp',
  truecaller: 'truecaller'
};
var OTP_TYPE = {
  sms: 'mobile',
  whatsApp: 'whatsapp'
};
var OTP_RESEND_TIME = 30;
var EXISTING_USER_INTENT = 'LOGIN';
var CONFIG_KEY_MWEB_AUTH = 'mweb_auth_config';

var DEFAULT_VALUE = {
  activeAuthFlow: AUTH_FLOW_STEPS.STEP_MOBILE,
  loginType: LOGIN_TYPE.otp,
  isTruecallerShown: false
};
var useAuthFlow = create(function (set) {
  return _extends({}, DEFAULT_VALUE, {
    setActiveAuthFlow: function setActiveAuthFlow(type) {
      return set({
        activeAuthFlow: type
      });
    },
    setLoginType: function setLoginType(type) {
      return set({
        loginType: type
      });
    },
    setIsTruecallerShown: function setIsTruecallerShown(value) {
      return set({
        isTruecallerShown: value
      });
    },
    resetActiveAuthFlow: function resetActiveAuthFlow() {
      return set(_extends({}, DEFAULT_VALUE));
    }
  });
});

/** Create a new configStore instance for mweb-auth */
var useConfigStore = createConfigStore();

var _templateObject$7, _templateObject2$5, _templateObject3$1;
var CloseButton = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\ttop: -100px;\n\twidth: 20px;\n\theight: 20px;\n\tright: 8px;\n\t.login_Button::before,\n\t.login_Button::after {\n\t\tcontent: '';\n\t\tdisplay: inline-block;\n\t\twidth: 18px;\n\t\theight: 2px;\n\t\ttop: 8px;\n\t\tbackground: #b0b0b0;\n\t\tposition: absolute;\n\t}\n\t.login_Button::before {\n\t\ttransform: rotate(-45deg);\n\t}\n\t.login_Button::after {\n\t\ttransform: rotate(45deg);\n\t}\n"])));
var LoginOffers = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n.loginOffersWrapper {\n    background: linear-gradient(315deg, #8734f3 0%, #3b41ff 100%);\n    overflow: hidden;\n    position: absolute;\n    height: 80px;\n    width: 100%;\n    top: -60px;\n    border-radius: 16px 16px 0px 0px;\n  animation: transitionUpInit 0.5s ease-in-out;\n  }\n  .loginOfferInnerWrapper {\n    padding: 16px 16px;\n    display: flex;\n    align-items: center;\n    animation: ", "\n    transform: ", ";\n    color: #fff;\n    ", "\n  }\n\n  .loginOfferImg {\n    margin-right: 16px;\n  }\n  @keyframes transitionUpInit {\n    0% {\n      transform: translateY(100%);\n    }\n    100%  {\n      transform: translateY(0);\n    }\n  }\n  @keyframes transitionUp {\n    0% {\n      transform: translateY(100%);\n    }\n    15% {\n      transform: translateY(0);\n    }\n    80% {\n      transform: translateY(0);\n    }\n    95% {\n      transform: translateY(100%);\n    }\n  }\n"])), function (props) {
  return props.animate ? 'transitionUp 2.5s ease-in-out infinite;' : 'none;';
}, function (props) {
  return props.animate ? 'translateY(100%);' : 'none;';
}, textSizes.BaseW3);
var LoginText = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n\tbackground: white;\n\tposition: relative;\n\tborder-radius: 16px 16px 0 0;\n\t.btmSheet__header.success {\n\t\tbackground-color: #e5f2ff;\n\t\tborder-bottom: 0;\n\t}\n\n\t.btmSheet__header--heading {\n\t\tcolor: #141823;\n\t\tmargin: 0 !important;\n\t\tborder-radius: 16px 16px 0px 0px;\n\t}\n\n\t.btmSheet__header.success {\n\t\tbackground-color: #e5f2ff;\n\t\tborder-bottom: 0;\n\t}\n\n\t.btmSheet__header--subHeading {\n\t\tcolor: #141823;\n\t\tmargin-top: 4px;\n\t}\n"])));

var DefaultDataList = [{
  id: 1,
  text: 'Rs 100 on Signup & earn goCash on bookings',
  icon: 'https://gos3.ibcdn.com/login_popup_gocash-1691558657.png'
}, {
  id: 2,
  text: 'Free seat selection, room upgrade etc.',
  icon: 'https://gos3.ibcdn.com/login_popup_gotribe-1691558681.png'
}, {
  id: 3,
  icon: 'https://gos3.ibcdn.com/login_popup_offer-1691558697.png',
  text: 'Exclusive deals for logged in users'
}];

var OfferLabel = function OfferLabel(_ref) {
  var icon = _ref.icon,
    text = _ref.text,
    animate = _ref.animate;
  return /*#__PURE__*/React.createElement(LoginOffers, {
    animate: animate
  }, /*#__PURE__*/React.createElement("div", {
    className: "loginOffersWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loginOfferInnerWrapper"
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: "loginOfferImg"
  }, /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: "Offer's Icon",
    style: {
      height: 30
    }
  })), text)));
};
var OffersLabel = /*#__PURE__*/React.memo(OfferLabel);

var HeaderWithLoginOffers = function HeaderWithLoginOffers(props) {
  var _configDataList$curre, _configDataList$curre2;
  var heading = props.heading,
    subHeading = props.subHeading,
    successTitle = props.successTitle,
    successSubTitle = props.successSubTitle,
    icon = props.icon,
    theme = props.theme,
    closeModal = props.closeModal,
    lobName = props.lobName,
    showCloseBtn = props.showCloseBtn;
  var _useState = useState([]),
    configDataList = _useState[0],
    setConfigDataList = _useState[1];
  var _useState2 = useState(0),
    currentItem = _useState2[0],
    setCurrentItem = _useState2[1];
  var _ref = useConfigStore(),
    configStoreResp = _ref.data,
    configStoreApiError = _ref.error,
    configStoreApiLoaded = _ref.loaded;
  useEffect(function () {
    var _configStoreResp$COMM;
    var configStoreData = configStoreResp == null || (_configStoreResp$COMM = configStoreResp.COMMON) == null ? void 0 : _configStoreResp$COMM[CONFIG_KEY_MWEB_AUTH];
    if (configStoreData && configStoreApiLoaded && !configStoreApiError) {
      setConfigDataList((configStoreData == null ? void 0 : configStoreData[lobName]) || DefaultDataList);
    } else if (configStoreApiError) {
      setConfigDataList(DefaultDataList);
    }
  }, [configStoreResp, lobName, configStoreApiLoaded, configStoreApiError]);
  useEffect(function () {
    var lastIndexofList = configDataList.length - 1;
    var interval;
    if (configDataList.length > 1) {
      interval = setInterval(function () {
        return setCurrentItem(function (prev) {
          if (prev < lastIndexofList) {
            return prev + 1;
          }
          return 0;
        });
      }, 2500);
    }
    return function () {
      if (interval) clearInterval(interval);
    };
  }, [configDataList]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, showCloseBtn && /*#__PURE__*/React.createElement(CloseButton, null, /*#__PURE__*/React.createElement("span", {
    className: "login_Button",
    onClick: closeModal || null,
    role: "presentation"
  })), configStoreApiLoaded || configDataList.length ? /*#__PURE__*/React.createElement(OffersLabel, {
    animate: configDataList.length > 1,
    icon: (_configDataList$curre = configDataList[currentItem]) == null ? void 0 : _configDataList$curre.icon,
    text: (_configDataList$curre2 = configDataList[currentItem]) == null ? void 0 : _configDataList$curre2.text
  }) : null, /*#__PURE__*/React.createElement(LoginText, null, /*#__PURE__*/React.createElement("div", {
    className: "btmSheet__header " + (theme || '')
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: "logSprite " + icon + " gr-append-right15"
  }), /*#__PURE__*/React.createElement("div", {
    className: "btmSheet__header--content"
  }, heading && /*#__PURE__*/React.createElement("h3", {
    className: "btmSheet__header--heading"
  }, heading), subHeading && /*#__PURE__*/React.createElement("p", {
    className: "btmSheet__header--subHeading",
    dangerouslySetInnerHTML: {
      __html: subHeading
    }
  }), successTitle && /*#__PURE__*/React.createElement("h3", {
    className: "gr-quickSand gr-quickSandBold gr-font18 gr-lightGreenText"
  }, successTitle), successSubTitle && /*#__PURE__*/React.createElement("p", {
    className: "gr-quickSand gr-quickSandBold gr-font16 gr-blackText gr-appendTop5"
  }, successSubTitle)))));
};

var AuthLayoutHeader = function AuthLayoutHeader(props) {
  var lobName = props.lobName,
    icon = props.icon,
    heading = props.heading,
    subHeading = props.subHeading,
    successTitle = props.successTitle,
    successSubTitle = props.successSubTitle,
    closeBtn = props.closeBtn,
    closeModal = props.closeModal,
    theme = props.theme;
  return /*#__PURE__*/React.createElement(HeaderWithLoginOffers, {
    icon: icon,
    subHeading: subHeading,
    successTitle: successTitle,
    successSubTitle: successSubTitle,
    lobName: lobName,
    heading: heading,
    theme: theme,
    closeModal: closeModal,
    showCloseBtn: closeBtn
  });
};

var _templateObject$6;
var authStepperWrapper = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n\tbackground: #fff;\n\tz-index: 10;\n\tposition: relative;\n\tborder-radius: 16px 16px 0 0;\n\t.close-btn-wrap {\n\t\tmargin-left: auto;\n\t\tpadding: 12px;\n\t}\n\n\t.btmSheet__close .logSprite icClose {\n\t\tcontent: '';\n\t\tdisplay: inline-block;\n\t\twidth: 18px;\n\t\theight: 2px;\n\t\ttop: 8px;\n\t\tbackground: #b0b0b0;\n\t\tposition: absolute;\n\t\t&::before {\n\t\t\ttransform: rotate(45deg);\n\t\t}\n\t\t&::after {\n\t\t\ttransform: rotate(-45deg);\n\t\t}\n\t}\n\n\t.btmSheet__header {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tpadding: 17px 20px;\n\t\talign-items: center;\n\t\tborder-bottom: 1px #e6e6e6 solid;\n\t\tborder-radius: 16px 16px 0 0;\n\t}\n\n\t.btmSheet__header.success {\n\t\tbackground-color: #e5f2ff;\n\t\tborder-bottom: 0;\n\t}\n\n\t.btmSheet__header--heading {\n\t\tcolor: #141823;\n\t\tmargin: 0 !important;\n\t}\n\n\t.btmSheet__header--subHeading {\n\t\tcolor: #141823;\n\t\tmargin-top: 4px;\n\t}\n\n\t.btmSheet__content {\n\t\tpadding: 20px 30px;\n\t\theight: auto;\n\t\tposition: relative;\n\t\tz-index: 10;\n\t\tbackground: #fff;\n\t}\n"])));

var AuthStepWrapper = function AuthStepWrapper(prop) {
  var lobName = prop.lobName,
    icon = prop.icon,
    heading = prop.heading,
    subHeading = prop.subHeading,
    successTitle = prop.successTitle,
    successSubTitle = prop.successSubTitle,
    closeBtn = prop.closeBtn,
    closeModal = prop.closeModal,
    theme = prop.theme,
    height = prop.height,
    children = prop.children;
  return /*#__PURE__*/React.createElement(authStepperWrapper, null, /*#__PURE__*/React.createElement(AuthLayoutHeader, {
    lobName: lobName,
    icon: icon,
    heading: heading,
    subHeading: subHeading,
    successTitle: successTitle,
    successSubTitle: successSubTitle,
    closeBtn: closeBtn,
    closeModal: closeModal,
    theme: theme
  }), /*#__PURE__*/React.createElement("div", {
    className: "btmSheet__content " + (height || '')
  }, children));
};

var _templateObject$5, _templateObject2$4;
var mobileContainer = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n\t.login__methods__list {\n\t\ttext-align: center;\n\t}\n\n\tinput:-webkit-autofill {\n\t\t-webkit-box-shadow: 0 0 0 50px white inset !important; /* Change the color of background for auto fill */\n\t\t-webkit-text-fill-color: #4f525a !important;\n\t}\n\n\tinput:-webkit-autofill:focus {\n\t\t-webkit-box-shadow: 0 0 0 50px white inset !important;\n\t\t-webkit-text-fill-color: #4f525a !important;\n\t}\n\n\t.loginCont__btn {\n\t\twidth: 100%;\n\t\theight: 47px;\n\t\tpadding: 13px 118px 13px 116px;\n\t\tmargin-top: 22px;\n\t\tborder-radius: 8px;\n\t\tbackground-color: #ff6d38;\n\t\tcolor: #fff;\n\t\toutline: 0;\n\t\tborder: 0;\n\t\tcursor: pointer;\n\t\t", "\n\t\t-webkit-appearance: none;\n\t}\n\t.loginCont__btn.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])), textSizes.BaseW2);
var Message = styled.p(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-top: 10px;\n\t", "\n"])), textSizes.SmallW1, function (props) {
  if (props.error) {
    return "color: rgb(229, 52, 66);";
  }
  return null;
});

var LOGIN_WITH_MOBILE = {
  heading: 'Login/Signup',
  subHeading: 'Mobile Number',
  placeholder: 'Enter 10 digit Mobile Number',
  submitButton: 'Continue',
  termsPolicy: 'By proceeding, you agree to GoIbibo’s <a href="https://www.goibibo.com/info/privacy/" target="_blank">Privacy Policy</a>, <a href="https://www.goibibo.com/info/user-agreement/" target="_blank">User Agreement</a> and <a href="https://www.goibibo.com/info/terms-of-services/" target="_blank">Terms of Service</a>'
};
var LOGIN_WITH_MOBILE_BOTTOM_SHEET = {
  icon: 'icGo',
  heading: 'Login / Sign up',
  subHeading: "Signup to get <span>&#8377; 100</span> goCash"
};

var _templateObject$4, _templateObject2$3;
var inputWrapper = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n\theight: 56px;\n\tborder-radius: 4px;\n\tborder: solid 2px #016eff;\n\tposition: relative;\n\tdisplay: flex;\n\t", "\n\n\t.loginCont__input {\n\t\tbackground: #fff;\n\t\twidth: 100%;\n\t\tborder: 0;\n\t\toutline: 0;\n\t\t", "\n\t\tcolor: #4f525a;\n\t\tpadding-left: 5px;\n\t\tborder-radius: 0 4px 4px 0;\n\t}\n\n\t.loginCont__code {\n\t\tbackground: #fff;\n\t\t", "\n\n\t\tcolor: #c2c2c2;\n\t\tdisplay: inline-flex;\n\t\tpadding: 0 5px 0 20px;\n\t\talign-items: center;\n\t\tflex-shrink: 0;\n\t}\n\n\t.loginCont__label {\n\t\tdisplay: inline-flex;\n\t\tposition: absolute;\n\t\tleft: 11px;\n\t\ttop: -11px;\n\t\tbackground-color: #fff;\n\t\tpadding: 3px 8px;\n\t\t", "\n\t\tcolor: #016eff;\n\t}\n\n\t.loginCont__input::placeholder {\n\t\tcolor: #c2c2c2;\n\t\t", "\n\t\topacity: 1;\n\t}\n"])), function (props) {
  if (props.error) {
    return "\n    border-color: rgb(229, 52, 66);\n    .loginCont__label {\n    \tcolor: rgb(229, 52, 66) !important;\n    }\n    ";
  }
  if (props.valid) {
    return "  \n\t\t\t\tborder-color: #00962d;\n\t\t\t\t .loginCont__label {\n\t\t\t\t \tcolor: #00962d !important;\n\t\t\t\t}\n\t\t\t\t";
  }
  return null;
}, textSizes.MediumW3, textSizes.MediumW2, textSizes.SmallW1, textSizes.MediumW2);
var InputMessageIcon = styled.span(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tright: 20px;\n\ttop: 17px;\n"])));

var InputWrapper = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    _ref$inputName = _ref.inputName,
    inputName = _ref$inputName === void 0 ? 'text' : _ref$inputName,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    maxlength = _ref.maxlength,
    _ref$inputType = _ref.inputType,
    inputType = _ref$inputType === void 0 ? 'text' : _ref$inputType,
    inputPrefix = _ref.inputPrefix,
    onChange = _ref.onChange,
    onInputClick = _ref.onInputClick,
    _ref$isError = _ref.isError,
    isError = _ref$isError === void 0 ? false : _ref$isError,
    _ref$isValid = _ref.isValid,
    isValid = _ref$isValid === void 0 ? false : _ref$isValid,
    inputClassName = _ref.inputClassName,
    placeholder = _ref.placeholder,
    inputVal = _ref.inputVal,
    _ref$inputDisabled = _ref.inputDisabled,
    inputDisabled = _ref$inputDisabled === void 0 ? false : _ref$inputDisabled;
  var onChangeHandler = function onChangeHandler(e) {
    if (onChange) onChange(e);
  };
  return /*#__PURE__*/React.createElement(inputWrapper, {
    error: isError,
    valid: isValid
  }, /*#__PURE__*/React.createElement("span", {
    className: "loginCont__label"
  }, label), inputPrefix && /*#__PURE__*/React.createElement("span", {
    className: "loginCont__code"
  }, inputPrefix), /*#__PURE__*/React.createElement("input", {
    ref: ref,
    className: inputClassName,
    onChange: onChangeHandler,
    onClick: onInputClick,
    type: inputType,
    maxLength: maxlength,
    name: inputName,
    autoFocus: autoFocus,
    placeholder: placeholder,
    value: inputVal,
    disabled: inputDisabled
  }), (isError || isValid) && /*#__PURE__*/React.createElement(InputMessageIcon, {
    className: "logSprite " + (isError ? 'icInfoPink' : 'icSuccessSmall')
  }));
});
InputWrapper.displayName = 'InputWrapper';

var MobileForm = function MobileForm(_ref) {
  var _data$error;
  var onFormSubmit = _ref.onFormSubmit,
    prefillMobileNumber = _ref.prefillMobileNumber,
    enableTruecaller = _ref.enableTruecaller,
    isMobileNumberDisabled = _ref.isMobileNumberDisabled,
    skipMobileScreen = _ref.skipMobileScreen;
  var _useState = useState(true),
    buttonDisabled = _useState[0],
    setButtonDisabled = _useState[1];
  var _useAnalytics = useAnalytics(),
    adobe = _useAnalytics.adobe;
  var _useNetwork = useNetwork(),
    isOnline = _useNetwork[0];
  var mobileNumberRef = useRef(undefined);
  var _useSendOtpStore = useSendOtpStore(function (s) {
      return {
        fetch: s.fetch,
        checkValid: s.checkValid,
        error: s.error,
        data: s.data,
        loading: s.loading
      };
    }, shallow),
    fetch = _useSendOtpStore.fetch,
    checkValid = _useSendOtpStore.checkValid,
    error = _useSendOtpStore.error,
    data = _useSendOtpStore.data,
    loading = _useSendOtpStore.loading;
  var _useAuthFlow = useAuthFlow(function (s) {
      return {
        setActiveAuthFlow: s.setActiveAuthFlow,
        isTruecallerShown: s.isTruecallerShown
      };
    }, shallow),
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow,
    isTruecallerShown = _useAuthFlow.isTruecallerShown;
  var _usePrefillLoginDetai = usePrefillLoginDetails(function (s) {
      return {
        prefillData: s.data,
        prefillfetch: s.fetch,
        prefillDetailsloaded: s.loaded,
        prefillLoading: s.loading,
        prefillError: s.error,
        controller: s.controller,
        setUserInputMobileNumber: s.setUserInputMobileNumber,
        userInputMobileNumber: s.userInputMobileNumber
      };
    }, shallow),
    prefillData = _usePrefillLoginDetai.prefillData,
    prefillfetch = _usePrefillLoginDetai.prefillfetch,
    prefillDetailsloaded = _usePrefillLoginDetai.prefillDetailsloaded,
    prefillLoading = _usePrefillLoginDetai.prefillLoading,
    prefillError = _usePrefillLoginDetai.prefillError,
    controller = _usePrefillLoginDetai.controller,
    setUserInputMobileNumber = _usePrefillLoginDetai.setUserInputMobileNumber,
    userInputMobileNumber = _usePrefillLoginDetai.userInputMobileNumber;
  var onKeyboardOpen = function onKeyboardOpen() {
    if (mobileNumberRef.current) {
      mobileNumberRef.current.scrollTo(0, 130);
    }
  };
  useEffect(function () {
    // this is added beacause in ios, keyboard overlaps the container,
    // so to trigger input field slide up this event is added.

    window.addEventListener('touchstart', onKeyboardOpen);
    return function () {
      window.removeEventListener('touchstart', onKeyboardOpen);
    };
  }, []);
  useEffect(function () {
    if (!prefillMobileNumber && !userInputMobileNumber) {
      prefillfetch({
        platform: 'mweb'
      });
    }
  }, [prefillMobileNumber, userInputMobileNumber]);
  var handleInputClick = function handleInputClick() {
    var _mobileNumberRef$curr;
    if (prefillLoading) {
      controller == null || controller.abort();
    }
    pdtPush("login_module_entry_mobile", {
      event_detail: {
        event_type: "click_event|onboarding_click",
        event_value: "onboarding_flow|mobileInput"
      }
    });
    if (isMobileEncoded(mobileNumberRef == null || (_mobileNumberRef$curr = mobileNumberRef.current) == null ? void 0 : _mobileNumberRef$curr.value, prefillData == null ? void 0 : prefillData.encodedMobileNumber)) {
      mobileNumberRef.current.value = '';
      setButtonDisabled(true);
    }
    if (enableTruecaller && isAndroidClient()) {
      if (!isTruecallerShown) {
        setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_TRUECALLER);
      }
    }
  };
  var onLoginSuccess = function onLoginSuccess() {
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Success',
        type: "itemSuccess",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (onFormSubmit) onFormSubmit();
  };
  var handleMobileSubmit = function handleMobileSubmit(e) {
    var _mobileNumberRef$curr2;
    if (e) e.preventDefault();
    if (!isOnline) {
      return;
    }
    // NOTE:
    // Triggering two GA events for OTP flow, one is to identify that user has
    // clicked on the button and another trigger post OTP API calls, which helps
    // to know that a user is old/new or does API failed or not.
    pdtPush("login_module_get_otp", {
      event_detail: {
        event_type: "click_event|onboarding_click",
        event_value: "onboarding_flow"
      }
    });
    adobe.track('ctaClick', {
      cta: {
        name: 'Continue_GetOTP_Clicked',
        type: "cardClick",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    var mobile = ((_mobileNumberRef$curr2 = mobileNumberRef.current) == null ? void 0 : _mobileNumberRef$curr2.value) || '';
    var isMobileNumberEncoded = isMobileEncoded(mobile, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
    var isValid = checkValid(mobile, isMobileNumberEncoded);
    if (isValid) {
      setUserInputMobileNumber(mobile);
      fetch({
        platform: 'mweb',
        data: {
          mobileNumber: mobile,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: isMobileNumberEncoded || undefined,
          loginType: 'MOBILE'
        },
        onSuccess: onLoginSuccess
      });
    }
  };
  var onChangeHandler = function onChangeHandler(e) {
    var _mobileNumberRef$curr3;
    setButtonDisabled(true);
    clearSendOtpStore();
    if (((_mobileNumberRef$curr3 = mobileNumberRef.current) == null ? void 0 : _mobileNumberRef$curr3.value.length) === 10) {
      setButtonDisabled(false);
      handleMobileSubmit(e);
    }
  };
  useEffect(function () {
    var prefillMobileNumberViaApi = prefillDetailsloaded && !prefillError ? prefillData == null ? void 0 : prefillData.encodedMobileNumber : null;
    if (prefillMobileNumber || userInputMobileNumber || prefillMobileNumberViaApi) {
      if (mobileNumberRef.current) mobileNumberRef.current.value = prefillMobileNumber || userInputMobileNumber || prefillMobileNumberViaApi;
      setButtonDisabled(false);
    }
    if (prefillMobileNumber && skipMobileScreen) {
      handleMobileSubmit();
    }
  }, [prefillMobileNumber, skipMobileScreen, prefillDetailsloaded, prefillError, prefillData, userInputMobileNumber]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputWrapper, {
    label: LOGIN_WITH_MOBILE.subHeading,
    inputName: "phone",
    maxlength: 10,
    inputType: "tel",
    inputPrefix: "+91 -",
    onChange: onChangeHandler,
    onInputClick: handleInputClick,
    isError: error || data.validation.message,
    isValid: data.validation.isValidMobile,
    inputClassName: "loginCont__input",
    placeholder: LOGIN_WITH_MOBILE.placeholder,
    ref: mobileNumberRef,
    inputDisabled: loading || !data.validation.message && isMobileNumberDisabled
  }), (error || data.validation.message || loading) && /*#__PURE__*/React.createElement(Message, {
    error: error || !!data.validation.message
  }, ((_data$error = data.error) == null ? void 0 : _data$error.errorMsg) || data.validation.message || 'Sending OTP...'), /*#__PURE__*/React.createElement("input", {
    className: "loginCont__btn " + (buttonDisabled ? 'disabled' : ''),
    type: "button",
    onClick: handleMobileSubmit,
    value: LOGIN_WITH_MOBILE.submitButton,
    disabled: false
  }));
};

// move tnc text to a bit up to avoid tnc text overlapping with the safari bottom bar */
var isSafari = isIOSSafariBrowser();
var TnCText = function TnCText(_ref) {
  var text = _ref.text,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: "loginCont__tnc " + (isSafari ? 'loginCont__tnc-safari' : ''),
    onClick: onClick || null
  }, /*#__PURE__*/React.createElement("p", {
    className: "gr-font12 gr-lineHight18",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};

var LoginWithMobile = function LoginWithMobile(props) {
  var isMobileNumberDisabled = props.isMobileNumberDisabled,
    hideWhatsApp = props.hideWhatsApp,
    prefillMobileNumber = props.prefillMobileNumber,
    enableTruecaller = props.enableTruecaller,
    skipMobileScreen = props.skipMobileScreen;
  var _useAnalytics = useAnalytics(),
    adobe = _useAnalytics.adobe;
  var setActiveAuthFlow = useAuthFlow(function (s) {
    return s.setActiveAuthFlow;
  });
  var handleFormSubmit = function handleFormSubmit(e) {
    if (e) e.preventDefault();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_OTP);
  };
  var redirectToWhatsApp = function redirectToWhatsApp() {
    // analyticsTrackAll('HAPPY_AUTH_WEBA__CLICK_LOGIN_VIA_WHATSAPP');
    // @ts-ignore
    window.top.location.href = 'https://api.whatsapp.com/send?phone=919213025552&text=Sign me into Goibibo Website';
  };
  var termsAndConditionClick = function termsAndConditionClick() {
    adobe.track('ctaClick', {
      cta: {
        name: "Login_TNC",
        type: "itemClick",
        componentName: "GI_USER_ONBOARDING"
      }
    });
  };
  return /*#__PURE__*/React.createElement(mobileContainer, {
    className: "loginCont"
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: function onSubmit(e) {
      return handleFormSubmit(e);
    },
    autoComplete: "on"
  }, /*#__PURE__*/React.createElement(MobileForm, {
    prefillMobileNumber: prefillMobileNumber,
    enableTruecaller: enableTruecaller,
    onFormSubmit: handleFormSubmit,
    isMobileNumberDisabled: isMobileNumberDisabled,
    skipMobileScreen: skipMobileScreen
  }), !hideWhatsApp && /*#__PURE__*/React.createElement("div", {
    className: "login__methods__list"
  }, /*#__PURE__*/React.createElement("p", {
    className: "gr-textCenter gr-appendTop15 gr-appendBottom15 gr-font12 gr-cap-text gr-blackText"
  }, "or"), /*#__PURE__*/React.createElement("div", {
    className: "gr-appendBottom15 gr-make-flex gr-perfectCenter"
  }, /*#__PURE__*/React.createElement("span", {
    className: "gr-helveticaBold gr-blackText gr-font12"
  }, "Login with :"), /*#__PURE__*/React.createElement("ul", {
    className: "otpScreen__social"
  }, /*#__PURE__*/React.createElement("li", {
    onClick: redirectToWhatsApp,
    role: "presentation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "logSprite icWhatsapp gr-appendRight10"
  }), /*#__PURE__*/React.createElement("span", {
    className: "gr-quickSand gr-quickSandBold gr-font12 gr-blackText"
  }, "WhatsApp")))))), /*#__PURE__*/React.createElement(TnCText, {
    onClick: termsAndConditionClick,
    text: LOGIN_WITH_MOBILE.termsPolicy
  }));
};

var _templateObject$3, _templateObject2$2, _templateObject3, _templateObject4, _templateObject5;
var OtpContainer = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n\t.otpScreen__social {\n\t\tdisplay: flex;\n\t}\n\n\t.otpScreen__social > li {\n\t\twidth: 100px;\n\t\tmargin: 0 0 0 10px;\n\t\tpadding: 4px 14px 5px 8px;\n\t\tborder-radius: 2px;\n\t\tborder: solid 1px #cecece;\n\t\tbackground-color: #fff;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t}\n\n\t.otpScreen__social > li .gi-resend-sms {\n\t\tdisplay: none;\n\t}\n\n\t.otpScreen__social > li:hover .gi-resend-sms {\n\t\tdisplay: block;\n\t}\n\n\t.disableInfo .otpScreen__social > li .gi-resend-sms {\n\t\tdisplay: none;\n\t}\n\n\t.disableInfo {\n\t\topacity: 0.3;\n\t\tpointer-events: none;\n\t}\n\t.verifyOtpCont {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n\t.verifyOtpCont__otpCont > div {\n\t\tmargin-right: 16px;\n\t}\n\n\t.verifyOtpCont__otpCont {\n\t\tjustify-content: space-between;\n\t}\n\n\t.verifyOtpCont__otpCont > div:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t.verifyOtpCont__otpFiled {\n\t\theight: 56px;\n\t\tborder-radius: 4px;\n\t\tborder: solid 2px #016eff;\n\n\t\t", "\n\t\tcolor: #4f525a;\n\t\toutline: 0;\n\t\ttext-align: left;\n\t\tpadding-left: 15px;\n\t}\n\n\t.verifyOtpCont__otpFiled.disabled {\n\t\tborder: solid 1px #4f525a;\n\t\tbackground-color: #fff;\n\t}\n\n\t.verifyOtpCont__message {\n\t\tmin-height: 14px;\n\t\tpadding: 0px 0px 10px 0px;\n\t}\n\n\t.otpSuccess .verifyOtpCont__otpFiled {\n\t\tborder-color: #00962d;\n\t}\n\n\t.otpError .verifyOtpCont__otpFiled {\n\t\tborder-color: #e53442;\n\t}\n\n\t@media (hover: none) {\n\t\t.otpScreen__social > li .csTooltip {\n\t\t\tdisplay: none !important;\n\t\t}\n\t}\n"])), textSizes.MediumW2);
var MessageText = styled.p(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tjustify-content: left;\n\tmargin-top: 8px;\n\talign-items: center;\n\t.otp_loading {\n\t\tmargin-left: 10px;\n\t\tfont-size: 12px;\n\t}\n\t.otp_error_msg {\n\t\t", "\n\t\tcolor: #e53442;\n\t}\n"])), textSizes.SmallW1);
var ResendOtpTimerContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n\t", "\n\tmargin-bottom: 10px;\n"])), textSizes.SmallW1);
var ResendOtpTimer = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n\tcolor: #000;\n\t", "\n\tmargin-left: 5px;\n"])), textSizes.SmallW2);
var ResendSmsTypeContainer = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\talign-items: center;\n"])));

var LOGIN_WITH_OTP = {
  subHeading: 'Enter 4 digit OTP sent to',
  otpVerifiedMsg: 'OTP verified',
  otpVerifyingMsg: 'Verifying OTP...',
  otpPlaceholder: 'Enter Here',
  invalidOtpMsg: 'Please enter a valid OTP',
  disclaimer: 'I agree to receive critical messages such as OTP, booking details on WhatsApp.'
};
var RESEND_OTP = {
  label: 'Didn\'t get the OTP?'
};
var VERIFY_OTP_CLOSE_DIALOG = {
  heading: 'You\'ll lose on ₹100 Sign-up goCash',
  description: 'Are you sure you want to end the login verification process?'
};
var BOTTOM_SHEET_OTP = {
  icon: 'icGo',
  heading: 'Verify OTP',
  subHeading: ''
};

function autoReadSMS() {
  var ac;
  if (typeof AbortController !== 'undefined') {
    ac = new AbortController();
  } else {
    ac = {
      abort: {}
    };
  }
  var autoFetchSms = function autoFetchSms(cb) {
    if (isOnClient && 'OTPCredential' in window) {
      // @ts-ignore
      navigator.credentials.get({
        otp: {
          transport: ['sms']
        },
        signal: ac.signal
      }).then(function (otp) {
        cb(otp == null ? void 0 : otp.code);
        // window['gtm'].track('HAPPY_AUTH_WEBA__AUTO_VERIFY_SMS')
        // console.log(`otp received${otp?.code}`);
      })["catch"](function () {
        console.log('auto fetch failed');
      });
    } else {
      // eslint-disable-next-line no-console
      console.log('********** Autofetch Not Supported **********');
    }
  };
  return {
    autoFetchSms: autoFetchSms,
    abortController: ac
  };
}

var OtpInputWrapper = function OtpInputWrapper(_ref) {
  var mobileNumber = _ref.mobileNumber,
    onOtpSuccess = _ref.onOtpSuccess,
    isExistingUser = _ref.isExistingUser,
    error = _ref.error,
    errorMsg = _ref.errorMsg;
  var _useState = useState(false),
    otpVerifying = _useState[0],
    setOtpVerifying = _useState[1];
  var _useState2 = useState(error),
    otpError = _useState2[0],
    setOtpError = _useState2[1];
  var _useState3 = useState(errorMsg),
    otpErrorMsg = _useState3[0],
    setOtpErrorMsg = _useState3[1];
  var otpRef = useRef(null);
  var otpData = useSendOtpStore(function (state) {
    return state.data;
  });
  var fetchLoginDetails = useLoginUserStore(function (s) {
    return s.fetch;
  });
  var verifyNewUser = useSignupViaOTPStore(function (s) {
    return s.fetch;
  });
  var _autoReadSMS = autoReadSMS(),
    autoFetchSms = _autoReadSMS.autoFetchSms,
    abortController = _autoReadSMS.abortController;
  var _usePrefillLoginDetai = usePrefillLoginDetails(function (s) {
      return {
        prefillData: s.data
      };
    }, shallow),
    prefillData = _usePrefillLoginDetai.prefillData;
  var onOtpVerificationSuccess = function onOtpVerificationSuccess(profileDetails) {
    setOtpVerifying(false);
    if (onOtpSuccess) onOtpSuccess(profileDetails);
  };
  var onOtpVerificationError = function onOtpVerificationError(opts) {
    var _ref2 = opts || {},
      code = _ref2.code;
    setOtpVerifying(false);
    setOtpError(true);
    if (code && code === INVALID_OTP_CODE) {
      setOtpErrorMsg(LOGIN_WITH_OTP.invalidOtpMsg);
    } else {
      setOtpErrorMsg('Some error occurred, please try again.');
    }
  };
  var handleOtpChange = function handleOtpChange(e) {
    var value = e.target.value;
    // setOtp(e.target.value);
    if (value.length === 4 && !otpVerifying) {
      pdtPush("login_module_verify_otp_auto", {
        event_detail: {
          event_type: "click_event",
          event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
        }
      });
      setOtpVerifying(true);
      if (isNumberValid(value)) {
        abortController.abort();
        if (isExistingUser) {
          fetchLoginDetails({
            platform: 'mweb',
            data: {
              mobileNumber: mobileNumber,
              passwordType: 'OTP',
              password: value,
              encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
              isEncoded: otpData.isMobileNumberEncoded || undefined
            },
            onSuccess: onOtpVerificationSuccess,
            onError: onOtpVerificationError
          });
        } else {
          verifyNewUser({
            platform: 'mweb',
            data: {
              mobileNumber: mobileNumber,
              passwordType: 'OTP',
              password: value
            },
            onSuccess: onOtpVerificationSuccess,
            onError: onOtpVerificationError
          });
        }
      }
    }
  };
  var autoReadOtp = function autoReadOtp(value) {
    if (value) {
      handleOtpChange({
        target: {
          value: value
        }
      });
    }
  };
  var handleOtpInputClick = function handleOtpInputClick() {
    pdtPush("login_module_otp_entry", {
      event_detail: {
        event_type: "click_event|onboarding_click",
        event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
      }
    });
  };
  useEffect(function () {
    autoFetchSms(autoReadOtp);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "verifyOtpCont  " + (otpError ? 'otpError' : '')
  }, /*#__PURE__*/React.createElement("input", {
    defaultValue: "",
    onChange: handleOtpChange,
    maxLength: 4,
    className: otpVerifying ? 'verifyOtpCont__otpFiled disabled' : 'verifyOtpCont__otpFiled',
    type: "tel",
    autoFocus: true,
    placeholder: LOGIN_WITH_OTP.otpPlaceholder,
    disabled: otpVerifying,
    autoComplete: "one-time-code",
    ref: otpRef,
    onClick: handleOtpInputClick
  }), /*#__PURE__*/React.createElement("div", {
    className: "verifyOtpCont__message"
  }, otpVerifying && /*#__PURE__*/React.createElement(MessageText, null, /*#__PURE__*/React.createElement(CircularLoader, {
    theme: "blue"
  }), /*#__PURE__*/React.createElement("p", {
    className: "otp_loading"
  }, LOGIN_WITH_OTP.otpVerifyingMsg)), otpError && !otpVerifying && /*#__PURE__*/React.createElement(MessageText, null, /*#__PURE__*/React.createElement("span", {
    className: "logSprite icInfoPink gr-appendRight10"
  }), /*#__PURE__*/React.createElement("span", {
    className: "otp_error_msg"
  }, otpErrorMsg))));
};
var OtpInputWrapper$1 = /*#__PURE__*/React.memo(OtpInputWrapper);

var tooltipStyle = {
  width: '250px',
  top: 32
};
var tooltipStyle2 = {
  width: '250px',
  top: 32,
  right: 14
};
var ResendOtp = function ResendOtp(_ref) {
  var isExistingUser = _ref.isExistingUser;
  var _useSendOtpStore = useSendOtpStore(function (state) {
      return {
        resendOtpApi: state.fetch,
        apiLoading: state.loading,
        mobileNumber: state.data.mobileNumber
      };
    }, shallow),
    resendOtpApi = _useSendOtpStore.resendOtpApi,
    mobileNumber = _useSendOtpStore.mobileNumber,
    apiLoading = _useSendOtpStore.apiLoading;
  var _usePrefillLoginDetai = usePrefillLoginDetails(function (s) {
      return {
        prefillData: s.data
      };
    }, shallow),
    prefillData = _usePrefillLoginDetai.prefillData;
  var _useState = useState(OTP_RESEND_TIME),
    resendTimer = _useState[0],
    setResendTimer = _useState[1];
  var _useState2 = useState(true),
    isTimerActive = _useState2[0],
    setIsTimerActive = _useState2[1];
  var _useAnalytics = useAnalytics();
    _useAnalytics.ga;
    _useAnalytics.pdt;
    var adobe = _useAnalytics.adobe;
  useEffect(function () {
    var timerInterval;
    if (isTimerActive) {
      if (resendTimer === 0) {
        clearInterval(timerInterval);
        setIsTimerActive(false);
      }
      timerInterval = setInterval(function () {
        setResendTimer(function (timer) {
          return timer - 1;
        });
      }, 1000);
    }
    return function () {
      clearInterval(timerInterval);
    };
  }, [isTimerActive, resendTimer]);
  var resendOtp = function resendOtp(type) {
    if (!apiLoading) {
      pdtPush("login_module_resend_otp|" + type, {
        event_detail: {
          event_type: "click_event|onboarding_click",
          event_value: "onboarding_flow|" + (isExistingUser ? "login" : "signup")
        }
      });
      adobe.track('ctaClick', {
        cta: {
          name: "resend_otp",
          type: "cardClick|method:" + type + "|flow:" + (isExistingUser ? 'login' : 'signup'),
          componentName: 'GI_USER_ONBOARDING'
        }
      });
      var isMobileNumberEncoded = isMobileEncoded(mobileNumber, prefillData == null ? void 0 : prefillData.encodedMobileNumber);
      resendOtpApi({
        platform: 'mweb',
        data: {
          mobileNumber: mobileNumber,
          loginType: type,
          encodedLoginId: (prefillData == null ? void 0 : prefillData.encLoginId) || '',
          isEncoded: isMobileNumberEncoded || undefined
        },
        onSuccess: function onSuccess() {
          setResendTimer(OTP_RESEND_TIME);
          setIsTimerActive(true);
        }
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ResendOtpTimerContainer, null, RESEND_OTP.label, ' ', resendTimer ? /*#__PURE__*/React.createElement("span", null, "Resend OTP in", /*#__PURE__*/React.createElement(ResendOtpTimer, null, resendTimer < 10 ? "00:0" + resendTimer : "00:" + resendTimer)) : null), /*#__PURE__*/React.createElement(ResendSmsTypeContainer, {
    className: " " + (resendTimer ? 'disableInfo' : '')
  }, /*#__PURE__*/React.createElement(ResendOtpTimer, null, "Resend via :"), /*#__PURE__*/React.createElement("ul", {
    className: "otpScreen__social"
  }, /*#__PURE__*/React.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.whatsApp);
    },
    role: "presentation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "logSprite icWhatsapp gr-append-right5"
  }), /*#__PURE__*/React.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "WhatsApp"), /*#__PURE__*/React.createElement(ToolTip, {
    customClass: "gi-resend-sms",
    customStyle: tooltipStyle,
    notchPosition: "middle"
  }, /*#__PURE__*/React.createElement("p", {
    className: "gr-font12"
  }, "Please ensure that you have entered your WhatsApp number for OTP"))), /*#__PURE__*/React.createElement("li", {
    onClick: function onClick() {
      return resendOtp(OTP_TYPE.sms);
    },
    role: "presentation"
  }, /*#__PURE__*/React.createElement("span", {
    className: "logSprite icSms gr-appendRight10"
  }), /*#__PURE__*/React.createElement("span", {
    className: "gr-quicksand gr-quickSandBold gr-font12 gr-blackText"
  }, "SMS"), /*#__PURE__*/React.createElement(ToolTip, {
    customClass: "gi-resend-sms",
    customStyle: tooltipStyle2,
    notchPosition: "right"
  }, /*#__PURE__*/React.createElement("p", {
    className: "gr-font12"
  }, "Please don\u2019t share your OTP with anyone"))))));
};

var LoginWithOtp = function LoginWithOtp(_ref) {
  var _ref$isMobileNumberDi = _ref.isMobileNumberDisabled,
    isMobileNumberDisabled = _ref$isMobileNumberDi === void 0 ? false : _ref$isMobileNumberDi;
  var _useSendOtpStore = useSendOtpStore(function (s) {
      return s.data;
    }),
    mobileNumber = _useSendOtpStore.mobileNumber,
    data = _useSendOtpStore.data,
    error = _useSendOtpStore.error,
    errorMsg = _useSendOtpStore.errorMsg;
  var _useAuthFlow = useAuthFlow(function (s) {
      return {
        setActiveAuthFlow: s.setActiveAuthFlow,
        setLoginType: s.setLoginType
      };
    }, shallow),
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow,
    setLoginType = _useAuthFlow.setLoginType;
  var _useAnalytics = useAnalytics();
    _useAnalytics.ga;
    _useAnalytics.pdt;
    var adobe = _useAnalytics.adobe;
    _useAnalytics.analyticsTrackAll;
  useEffect(function () {
    setLoginType(LOGIN_TYPE.otp);
    adobe.track('ctaClick', {
      cta: {
        name: 'OTP_Screen_Loaded',
        type: "itemLoaded|flow:" + (data.statusCode === EXISTING_USER_STATUS_CODE ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
    pdtPush("login_module_otp", {
      event_detail: {
        event_type: "load_event|onboarding_click",
        event_value: "onboarding_flow|" + (data.statusCode === EXISTING_USER_STATUS_CODE ? 'login' : 'signup')
      }
    });
  }, []);
  var editMobileHandler = function editMobileHandler() {
    clearSendOtpStore();
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    adobe.track('ctaClick', {
      cta: {
        name: "Edit_Phone_Number",
        destination: 'Login_Popup_Load',
        type: "itemClick|flow:" + (data.statusCode === EXISTING_USER_STATUS_CODE ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
    pdtPush("login_module_edit_number", {
      event_detail: {
        event_type: "click_event|onboarding_click",
        event_value: "onboarding_flow|" + (data.statusCode === EXISTING_USER_STATUS_CODE ? 'login' : 'signup')
      }
    });
  };
  var handleOtpSuccess = function handleOtpSuccess() {
    adobe.track('User_Login', {
      account: {
        accountInfo: {
          custID: getUuidFromCookie(),
          flow: "" + (data.statusCode === EXISTING_USER_STATUS_CODE ? 'login' : 'signup')
        }
      },
      cta: {
        type: 'manual',
        name: "Onboarding_" + (data.statusCode === EXISTING_USER_STATUS_CODE ? 'Login' : 'Signup') + "_Success",
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_POST_AUTH);
  };
  return /*#__PURE__*/React.createElement(OtpContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "otpScreen"
  }, /*#__PURE__*/React.createElement("p", {
    className: "gr-append-bottom30"
  }, LOGIN_WITH_OTP.subHeading, /*#__PURE__*/React.createElement("span", {
    className: "gr-helveticaBold gr-append-left6"
  }, mobileNumber), ' ', !isMobileNumberDisabled && /*#__PURE__*/React.createElement("span", {
    className: "logSprite icEdit",
    onClick: editMobileHandler,
    role: "presentation"
  })), /*#__PURE__*/React.createElement(OtpInputWrapper$1, {
    error: error,
    errorMsg: errorMsg,
    mobileNumber: mobileNumber,
    onOtpSuccess: handleOtpSuccess,
    isExistingUser: data.statusCode === EXISTING_USER_STATUS_CODE
  }), /*#__PURE__*/React.createElement(ResendOtp, {
    isExistingUser: data.statusCode === EXISTING_USER_STATUS_CODE
  })), /*#__PURE__*/React.createElement(TnCText, {
    text: LOGIN_WITH_OTP.disclaimer
  }));
};

var _templateObject$2, _templateObject2$1;
var PostLoginContainer = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n\tform .gi-marginBottom25 {\n\t\tmargin-bottom: 25px;\n\t}\n\t.loginCont__input {\n\t\tpadding-left: 15px;\n\t}\n\t.loginCont__btn.disabled {\n\t\tbackground-color: #cecece;\n\t\tpointer-events: none;\n\t}\n"])));
var ErrorMessage = styled.p(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n\tcolor: #e53442;\n\tfont-size: 12px;\n\tmargin-top: 10px;\n"])));

var BOTTOM_SHEET_PROFILE_UPDATE = {
  icon: 'icSuccessBig',
  title: 'Congratulations!',
  subTitleNewUser: 'Account created successfully',
  subTitleExistingUser: 'Login Successful'
};
var UPDATE_PROFILE = {
  title: 'Just one more thing.',
  forms: {
    inputName: {
      title: 'What do we call you?',
      placeholder: 'Enter your full name',
      invalidName: 'Please enter valid name using only alphabets'
    },
    inputEmail: {
      title: 'What\'s your email id?',
      placeholder: 'Enter your email address',
      invalidEmail: 'Enter a valid email'
    }
  },
  cta: {
    letsGo: 'Lets Go',
    later: 'I’ll do it later'
  }
};
var VALIDATION_MSG = {
  email: {
    invalid: "Enter a valid email"
  },
  name: {
    invalid: "Please enter valid name using only alphabets"
  }
};

var ProfileUpdateForm = function ProfileUpdateForm(_ref) {
  var onProfileUpdateSubmit = _ref.onProfileUpdateSubmit,
    _ref$firstName = _ref.firstName,
    firstName = _ref$firstName === void 0 ? '' : _ref$firstName,
    _ref$primaryEmailId = _ref.primaryEmailId,
    primaryEmailId = _ref$primaryEmailId === void 0 ? '' : _ref$primaryEmailId,
    handleDoItLaterClick = _ref.handleDoItLaterClick,
    apiFailureMsg = _ref.apiFailureMsg,
    isExistingUser = _ref.isExistingUser,
    isTruecallerLogin = _ref.isTruecallerLogin;
  var _useState = useState(''),
    name = _useState[0],
    setName = _useState[1];
  var _useState2 = useState(''),
    email = _useState2[0],
    setEmail = _useState2[1];
  var _useState3 = useState(false),
    canSubmit = _useState3[0],
    setCanSubmit = _useState3[1];
  var _useState4 = useState(false),
    isError = _useState4[0],
    setIsError = _useState4[1];
  var _useState5 = useState(''),
    errorMsg = _useState5[0],
    setErrorMsg = _useState5[1];
  var _useAnalytics = useAnalytics(),
    adobe = _useAnalytics.adobe;
  useEffect(function () {
    setErrorMsg(apiFailureMsg);
    setIsError(!!apiFailureMsg);
  }, [apiFailureMsg]);
  useEffect(function () {
    if (name || email) {
      setCanSubmit(true);
    } else {
      setCanSubmit(false);
      setIsError(false);
    }
  }, [name, email]);
  var handleNameChange = function handleNameChange(e) {
    setName(e.target.value);
  };
  var handleEmailChange = function handleEmailChange(e) {
    setEmail(e.target.value);
  };
  var validateProfileUpdate = function validateProfileUpdate(_ref2) {
    var _ref2$fullName = _ref2.fullName,
      fullName = _ref2$fullName === void 0 ? '' : _ref2$fullName,
      _ref2$inputEmail = _ref2.inputEmail,
      inputEmail = _ref2$inputEmail === void 0 ? '' : _ref2$inputEmail;
    if (fullName && email) {
      if (!isEmailValid(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
      if (!isNameValid(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }
    if (!fullName && inputEmail) {
      if (!isEmailValid(inputEmail)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.email.invalid
      };
    }
    if (!inputEmail && fullName) {
      if (!isNameValid(fullName)) return {
        isValid: false,
        errorMessage: VALIDATION_MSG.name.invalid
      };
    }
    return {
      isValid: true,
      errorMessage: ''
    };
  };
  var handleSubmit = function handleSubmit(e) {
    if (e) e.preventDefault();
    var _validateProfileUpdat = validateProfileUpdate({
        fullName: name,
        inputEmail: email
      }),
      isValid = _validateProfileUpdat.isValid,
      errorMessage = _validateProfileUpdat.errorMessage;
    if (isValid) {
      if (onProfileUpdateSubmit) onProfileUpdateSubmit({
        fullName: name,
        email: email
      });
    } else {
      setErrorMsg(errorMessage);
      setIsError(true);
    }
  };
  var handleSkipClick = function handleSkipClick() {
    if (handleDoItLaterClick) handleDoItLaterClick();
  };
  useEffect(function () {
    if (isTruecallerLogin && !isExistingUser) {
      setName(firstName);
      setEmail(primaryEmailId);
    }
  }, [firstName, primaryEmailId]);
  useEffect(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Profile_Update_Screen_Loaded',
        type: "itemLoaded|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: "GI_USER_ONBOARDING"
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("p", {
    className: "gr-appendBottom20 gr-lineHight18"
  }, UPDATE_PROFILE.title), !firstName || !isExistingUser ? /*#__PURE__*/React.createElement("div", {
    className: "gi-marginBottom25"
  }, /*#__PURE__*/React.createElement(InputWrapper, {
    type: "text",
    name: "name",
    label: "What do we call you?",
    placeholder: "Enter your full name",
    inputClassName: "loginCont__input",
    inputVal: name,
    onChange: handleNameChange
  })) : null, !primaryEmailId || !isExistingUser ? /*#__PURE__*/React.createElement(InputWrapper, {
    type: "email",
    name: "Email",
    label: "What's your email id?",
    placeholder: "Enter your email address",
    inputClassName: "loginCont__input",
    inputVal: email,
    onChange: handleEmailChange
  }) : null, isError && /*#__PURE__*/React.createElement(ErrorMessage, null, errorMsg, " "), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "loginCont__btn" + (!canSubmit ? ' disabled' : '')
  }, UPDATE_PROFILE.cta.letsGo)), /*#__PURE__*/React.createElement("p", {
    className: "gr-textCenter gr-appendTop30"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "quicksand gr-quickSandBold gr-pointer btn-hyperlink gr-font14",
    onClick: handleSkipClick || null
  }, UPDATE_PROFILE.cta.later)));
};

var UpdateProfile = function UpdateProfile(_ref) {
  var _userData$data, _truecallerData$data;
  var closeAndLogin = _ref.closeAndLogin,
    onLoginComplete = _ref.onLoginComplete,
    showLoginToast = _ref.showLoginToast,
    lobName = _ref.lobName;
  var _useState = useState(''),
    apiFailureMsg = _useState[0],
    setApiFailureMsg = _useState[1];
  var _useAnalytics = useAnalytics();
    _useAnalytics.ga;
    var pdt = _useAnalytics.pdt,
    adobe = _useAnalytics.adobe,
    analyticsTrackAll = _useAnalytics.analyticsTrackAll;
  var loginType = useAuthFlow(function (s) {
    return s.loginType;
  });
  var truecallerData = useTruecallerLoginStore(function (s) {
    return s.data;
  });
  var _useSendOtpStore = useSendOtpStore(function (s) {
      return s.data;
    }),
    data = _useSendOtpStore.data,
    mobileNumber = _useSendOtpStore.mobileNumber;
  var _useLoginUserStore = useLoginUserStore(function (s) {
      return {
        userDetails: s.data,
        fetchLoginDetails: s.fetch
      };
    }, shallow),
    userDetails = _useLoginUserStore.userDetails,
    fetchLoginDetails = _useLoginUserStore.fetchLoginDetails;
  var _useSignupViaOTPStore = useSignupViaOTPStore(function (s) {
      var _s$data;
      return {
        transactionId: (_s$data = s.data) == null ? void 0 : _s$data.transactionId,
        createNewUser: s.createUser
      };
    }, shallow),
    transactionId = _useSignupViaOTPStore.transactionId,
    createNewUser = _useSignupViaOTPStore.createNewUser;
  var updateUserDetails = useProfileUpdateStore(function (s) {
    return s.fetch;
  });
  var isTruecallerLogIn = loginType === LOGIN_TYPE.truecaller;
  var userData = isTruecallerLogIn ? truecallerData : userDetails;
  var profileDetails = (userData == null || (_userData$data = userData.data) == null || (_userData$data = _userData$data.profileLoginResponse) == null ? void 0 : _userData$data[0]) || {};
  var _ref2 = profileDetails.userDetails || {},
    _ref2$extendedUser = _ref2.extendedUser,
    extendedUser = _ref2$extendedUser === void 0 ? {} : _ref2$extendedUser;
  var _extendedUser$persona = extendedUser.personalDetails,
    personalDetails = _extendedUser$persona === void 0 ? {} : _extendedUser$persona,
    _extendedUser$miscFie = extendedUser.miscFields,
    miscFields = _extendedUser$miscFie === void 0 ? {} : _extendedUser$miscFie,
    _extendedUser$loginIn = extendedUser.loginInfoList,
    loginInfoList = _extendedUser$loginIn === void 0 ? [] : _extendedUser$loginIn;
  var _ref3 = personalDetails || {},
    _ref3$name = _ref3.name,
    name = _ref3$name === void 0 ? {} : _ref3$name;
  var isExistingUser = isTruecallerLogIn ? ((_truecallerData$data = truecallerData.data) == null ? void 0 : _truecallerData$data.intent) === EXISTING_USER_INTENT : (data == null ? void 0 : data.statusCode) === EXISTING_USER_STATUS_CODE;
  var primaryEmailId = '';
  loginInfoList.forEach(function (item) {
    if (item.loginType === 'EMAIL') {
      primaryEmailId = item.loginId;
    }
  });
  if (!primaryEmailId) {
    primaryEmailId = miscFields == null ? void 0 : miscFields.altEmailId;
  }
  var onLoginSuccess = function onLoginSuccess() {
    pdt.track('HAPPY_AUTH_WEBA__CLICK_PROFILE_UPDATE');
    if (onLoginComplete) onLoginComplete(userData);
  };
  var onLoginError = function onLoginError() {
    setApiFailureMsg('Something went wrong, please try again.');
  };
  var onProfileUpdateSubmit = function onProfileUpdateSubmit(_ref4) {
    var fullName = _ref4.fullName,
      email = _ref4.email;
    setApiFailureMsg('');
    adobe.track('Profile_Completion');
    // If there is existing user or user coming from truecaller then we don't need  to hit create user api
    if (isExistingUser || isTruecallerLogIn) {
      var details = {
        mobileNumber: mobileNumber
      };
      if (fullName) details.firstName = fullName;
      if (email) details.email = email;
      updateUserDetails({
        data: details,
        platform: 'mweb',
        onError: onLoginError,
        onSuccess: onLoginSuccess
      });
    } else if (!isExistingUser) {
      createNewUser({
        platform: 'mweb',
        fullName: fullName,
        email: email,
        mobileNumber: mobileNumber,
        transactionId: transactionId
      }).then(function (res) {
        var _res$result;
        if (res != null && (_res$result = res.result) != null && _res$result.success) {
          fetchLoginDetails({
            platform: 'mweb',
            data: {
              mobileNumber: mobileNumber,
              passwordType: 'TRANSITION_ID',
              password: transactionId
            },
            onSuccess: onLoginSuccess,
            onError: onLoginError
          });
        } else {
          onLoginError();
        }
      })["catch"](function () {
        return onLoginError();
      });
    }
  };
  var handleDoItLaterClick = function handleDoItLaterClick() {
    analyticsTrackAll('HAPPY_AUTH_WEBA__CLICK_SKIP_PROFILE_UPDATE');
    adobe.track('ctaClick', {
      cta: {
        name: 'skip-profile-update',
        type: "itemClick|flow:" + (isExistingUser ? 'login' : 'signup'),
        componentName: 'GI_USER_ONBOARDING'
      }
    });
    if (isExistingUser || isTruecallerLogIn) {
      if (closeAndLogin) closeAndLogin();
    } else {
      onProfileUpdateSubmit({
        fullName: '',
        email: ''
      });
    }
  };
  var closeBtn = function closeBtn() {
    handleDoItLaterClick();
  };
  useEffect(function () {
    if (isExistingUser) {
      if (name.firstName && primaryEmailId) {
        showLoginToast(name.firstName);
        if (onLoginSuccess) onLoginSuccess();
      }
    }
  }, [isExistingUser, name, primaryEmailId, onLoginSuccess]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthStepWrapper, {
    icon: BOTTOM_SHEET_PROFILE_UPDATE.icon,
    successTitle: BOTTOM_SHEET_PROFILE_UPDATE.title,
    successSubTitle: isExistingUser ? BOTTOM_SHEET_PROFILE_UPDATE.subTitleExistingUser : BOTTOM_SHEET_PROFILE_UPDATE.subTitleNewUser,
    closeBtn: true,
    closeModal: closeBtn,
    theme: "success",
    lobName: lobName
  }, /*#__PURE__*/React.createElement(PostLoginContainer, null, /*#__PURE__*/React.createElement("div", {
    className: "updateProfileConatiner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "userDetails__dtl"
  }, /*#__PURE__*/React.createElement(ProfileUpdateForm, {
    apiFailureMsg: apiFailureMsg,
    primaryEmailId: primaryEmailId,
    firstName: name.firstName,
    handleDoItLaterClick: handleDoItLaterClick,
    onProfileUpdateSubmit: onProfileUpdateSubmit,
    isExistingUser: isExistingUser,
    isTruecallerLogin: isTruecallerLogIn
  }))))));
};

var ConfirmOTPStepClose = function ConfirmOTPStepClose(_ref) {
  var onConfirm = _ref.onConfirm;
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    onConfirm: onConfirm,
    heading: VERIFY_OTP_CLOSE_DIALOG.heading,
    description: VERIFY_OTP_CLOSE_DIALOG.description
  });
};

var _templateObject$1, _templateObject2;
var fadeInAnimation = keyframes(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n0% {\n  opacity: 0;\n}\n  100% {\n    opacity: 1;\n  }\n"])));
var TruecallerSkipCta = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n\t", "\n\tdisplay: flex;\n\tpadding: 12px 8px;\n\tjustify-content: center;\n\tflex-direction: column;\n\tcolor: #2276e3;\n\tcursor: pointer;\n\tanimation: ", " ease 3s;\n"])), textSizes.MediumW2, fadeInAnimation);

var LoginWithTruecaller = function LoginWithTruecaller(_ref) {
  var lobName = _ref.lobName,
    closeModal = _ref.closeModal;
  var _useState = useState(false),
    showSkipCta = _useState[0],
    setShowSkipCta = _useState[1];
  var truecallerSkipCtaTriggered = useRef(false);
  var _useAuthFlow = useAuthFlow(function (s) {
      return {
        setActiveAuthFlow: s.setActiveAuthFlow,
        setLoginType: s.setLoginType,
        setIsTruecallerShown: s.setIsTruecallerShown
      };
    }, shallow),
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow,
    setLoginType = _useAuthFlow.setLoginType,
    setIsTruecallerShown = _useAuthFlow.setIsTruecallerShown;
  var fetchTruecaller = useTruecallerLoginStore(function (s) {
    return s.fetch;
  });
  var _useAnalytics = useAnalytics(),
    pdt = _useAnalytics.pdt,
    adobe = _useAnalytics.adobe,
    analyticsTrackAll = _useAnalytics.analyticsTrackAll;
  useEffect(function () {
    setLoginType(LOGIN_TYPE.truecaller);
    adobe.track('ctaClick', {
      cta: {
        name: 'Truecaller_Popup_invoked',
        type: 'itemLoaded',
        componentName: 'GI_USER_ONBOARDING'
      }
    });
  }, []);
  var pollTruecallerLoginData = function pollTruecallerLoginData(reqNonce, apiInterval) {
    var truecallerApiInterval = apiInterval || TRUECALLER_DEEPLINK_DATA.PollingIntervalTimeout["default"];
    var truecallerHitCount = docSessionStorage.getItem(TRUECALLER_DEEPLINK_DATA.PollingTimeoutCountSessionKey);
    if (truecallerHitCount === TRUECALLER_DEEPLINK_DATA.PollingThreshold || truecallerSkipCtaTriggered.current) {
      setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
      docSessionStorage.removeItem(TRUECALLER_DEEPLINK_DATA.PollingTimeoutCountSessionKey);
      return;
    }
    var onTruecallerFetchSuccess = function onTruecallerFetchSuccess(res) {
      if ((res == null ? void 0 : res.message) === TRUECALLER_DEEPLINK_DATA.PollingState.pending) {
        pdt.track('growth_non_int_truecaller_polling', {
          custom1: Number(truecallerHitCount)
        });
        if (truecallerHitCount) {
          truecallerHitCount = Number(truecallerHitCount) + 1;
        } else {
          truecallerHitCount = 1;
        }
        if (truecallerHitCount > TRUECALLER_DEEPLINK_DATA.skipCtaTruecallerActivate) {
          setShowSkipCta(true);
        }
        if (truecallerHitCount > TRUECALLER_DEEPLINK_DATA.pollingHitStage.stage1 && truecallerHitCount <= TRUECALLER_DEEPLINK_DATA.pollingHitStage.stage2) {
          truecallerApiInterval = TRUECALLER_DEEPLINK_DATA.PollingIntervalTimeout.stage1;
        }
        if (truecallerHitCount > TRUECALLER_DEEPLINK_DATA.pollingHitStage.stage2) {
          truecallerApiInterval = TRUECALLER_DEEPLINK_DATA.PollingIntervalTimeout.stage2;
        }
        docSessionStorage.setItem(TRUECALLER_DEEPLINK_DATA.PollingTimeoutCountSessionKey, truecallerHitCount);
        pollTruecallerLoginData(reqNonce, truecallerApiInterval);
      } else if ((res == null ? void 0 : res.message) === TRUECALLER_DEEPLINK_DATA.PollingState.skipped) {
        adobe.track('ctaClick', {
          cta: {
            name: 'Truecaller_Popup_Skipped',
            type: "itemClick",
            componentName: "GI_USER_ONBOARDING"
          }
        });
        analyticsTrackAll('growth_non_int_truecaller_skipped');
        setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
      } else if (res.message === TRUECALLER_DEEPLINK_DATA.PollingState.complete) {
        var _res$data, _res$data2, _res$data3;
        setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_POST_AUTH);
        docSessionStorage.removeItem(TRUECALLER_DEEPLINK_DATA.PollingTimeoutCountSessionKey);
        analyticsTrackAll('HAPPY_AUTH_WEBA__UX_LOGIN_SUCCESS', {
          custom1: "existing:" + ((res == null || (_res$data = res.data) == null ? void 0 : _res$data.intent) === EXISTING_USER_INTENT) + ",type:truecaller"
        });
        adobe.track('User_Login', {
          account: {
            accountInfo: {
              custID: getEncryptedUuid(),
              flow: "" + ((res == null || (_res$data2 = res.data) == null ? void 0 : _res$data2.intent) === EXISTING_USER_INTENT ? 'login' : 'signup')
            }
          },
          cta: {
            type: 'truecaller',
            name: "Onboarding_" + ((res == null || (_res$data3 = res.data) == null ? void 0 : _res$data3.intent) === EXISTING_USER_INTENT ? 'Login' : 'Signup') + "_Success",
            componentName: 'GI_USER_ONBOARDING'
          }
        });
      } else {
        setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
      }
    };
    setTimeout(function () {
      fetchTruecaller({
        platform: 'mweb',
        data: {
          requestId: reqNonce
        },
        onSuccess: function onSuccess(res) {
          return onTruecallerFetchSuccess(res);
        },
        onError: function onError(err) {
          setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
          docSessionStorage.removeItem(TRUECALLER_DEEPLINK_DATA.PollingTimeoutCountSessionKey);
        }
      });
    }, truecallerApiInterval);
  };
  var handleTrueCallerSkip = function handleTrueCallerSkip() {
    truecallerSkipCtaTriggered.current = true;
    setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
    docSessionStorage.removeItem(TRUECALLER_DEEPLINK_DATA.PollingTimeoutCountSessionKey);
  };
  useEffect(function () {
    var truecallerInitTimeout = 600;
    var reqNonce = generateVid(); // random number of length 8 to 64 characters
    window.top.location = getTruecallerDeepLink(reqNonce, TRUECALLER_DEEPLINK_DATA);
    var truecallerInit = setTimeout(function () {
      // once truecaller loaded will not show truecaller again in that auth session
      setIsTruecallerShown(true);
      if (document.hasFocus()) {
        setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_MOBILE);
        analyticsTrackAll('growth_non_int_truecaller_triggered', {
          custom1: false
        });
      } else {
        analyticsTrackAll('growth_non_int_truecaller_triggered', {
          custom1: true
        });
        adobe.track('ctaClick', {
          cta: {
            name: 'Truecaller_Popup_Loaded',
            type: "itemLoaded",
            componentName: "GI_USER_ONBOARDING"
          }
        });
        pollTruecallerLoginData(reqNonce, TRUECALLER_DEEPLINK_DATA.PollingIntervalTimeout["default"]);
      }
    }, truecallerInitTimeout);
    return function () {
      if (truecallerInit) clearTimeout(truecallerInit);
    };
  }, []);
  return /*#__PURE__*/React.createElement(AuthStepWrapper, {
    lobName: lobName,
    heading: LOGIN_WITH_MOBILE_BOTTOM_SHEET.heading,
    closeBtn: showSkipCta,
    closeModal: closeModal
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      height: '223px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: showSkipCta ? 'space-evenly' : 'center'
    }
  }, /*#__PURE__*/React.createElement(CircularLoader, {
    theme: "blue full"
  }), showSkipCta ? /*#__PURE__*/React.createElement(TruecallerSkipCta, {
    onClick: handleTrueCallerSkip
  }, "Login with phone number ", '>') : null));
};

var AuthFlows = function AuthFlows(props) {
  var lobname = props.lobname,
    hideClose = props.hideClose,
    onClose = props.onClose,
    isMobileNumberDisabled = props.isMobileNumberDisabled,
    prefillMobileNumber = props.prefillMobileNumber,
    enableTruecaller = props.enableTruecaller,
    _props$isOnLoad = props.isOnLoad,
    isOnLoad = _props$isOnLoad === void 0 ? false : _props$isOnLoad,
    _props$loginViaWhatsA = props.loginViaWhatsApp,
    loginViaWhatsApp = _props$loginViaWhatsA === void 0 ? true : _props$loginViaWhatsA,
    onRender = props.onRender,
    onLoginSuccess = props.onLoginSuccess,
    setShowToast = props.setShowToast,
    _props$skipMobileScre = props.skipMobileScreen,
    skipMobileScreen = _props$skipMobileScre === void 0 ? false : _props$skipMobileScre;
  var _useAuthFlow = useAuthFlow(function (s) {
      return {
        activeAuthFlow: s.activeAuthFlow,
        setActiveAuthFlow: s.setActiveAuthFlow
      };
    }, shallow),
    activeAuthFlow = _useAuthFlow.activeAuthFlow,
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow;
  var _useAnalytics = useAnalytics(),
    adobe = _useAnalytics.adobe,
    analyticsTrackAll = _useAnalytics.analyticsTrackAll;
  var _useState = useState(false),
    confirmOtpClose = _useState[0],
    setConfirmOtpClose = _useState[1];
  var _use100Vh = use100Vh(),
    set100VhCssVar = _use100Vh[0];
  useLayoutEffect(function () {
    // set --100vh on css root var for bottom sheet height css
    set100VhCssVar();
  }, []);
  useEffect(function () {
    if (onRender) onRender();
  }, []);
  useEffect(function () {
    if (enableTruecaller && !isOnLoad && isAndroidClient()) {
      setActiveAuthFlow(AUTH_FLOW_STEPS.STEP_TRUECALLER);
    }
  }, [enableTruecaller, isOnLoad]);
  useEffect(function () {
    adobe.track('ctaClick', {
      cta: {
        name: 'Login_Popup_Load',
        type: "itemLoaded",
        componentName: "GI_USER_ONBOARDING"
      }
    });
    pdtPush("login_module_load", {
      event_detail: {
        event_type: "load_event|onboarding_click",
        event_value: "onboarding_flow|" + lobname
      }
    });
  }, []);
  var handleModalClose = function handleModalClose() {
    pdtPush("login_module_close", {
      event_detail: {
        event_type: "click_event",
        event_Value: "onboarding_flow|flow:" + activeAuthFlow
      }
    });
    // show a confirm dialog, if user is exiting from otp step
    if (activeAuthFlow === AUTH_FLOW_STEPS.STEP_OTP) {
      setConfirmOtpClose(true);
      return;
    }
    onClose();
  };
  var handleOTPStepCloseDialogConfirm = function handleOTPStepCloseDialogConfirm(resp) {
    analyticsTrackAll('HAPPY_AUTH_WEBA__CLICK_OTP_CONFIRM_CLOSE', {
      item_selected: resp.type
    });
    if (resp.type === CONFIRM_CTA.YES) {
      onClose();
    }
    setConfirmOtpClose(false);
  };
  var closeAndLogin = function closeAndLogin() {
    if (onLoginSuccess) onLoginSuccess();
    if (onClose) onClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, activeAuthFlow === AUTH_FLOW_STEPS.STEP_MOBILE && /*#__PURE__*/React.createElement(AuthStepWrapper, {
    lobName: lobname,
    heading: LOGIN_WITH_MOBILE_BOTTOM_SHEET.heading,
    closeBtn: !hideClose,
    closeModal: handleModalClose
  }, /*#__PURE__*/React.createElement(LoginWithMobile, {
    prefillMobileNumber: prefillMobileNumber,
    isMobileNumberDisabled: isMobileNumberDisabled,
    hideWhatsApp: loginViaWhatsApp,
    enableTruecaller: enableTruecaller && isOnLoad,
    skipMobileScreen: skipMobileScreen
  })), activeAuthFlow === AUTH_FLOW_STEPS.STEP_TRUECALLER && /*#__PURE__*/React.createElement(LoginWithTruecaller, {
    lobName: lobname,
    closeModal: handleModalClose
  }), activeAuthFlow === AUTH_FLOW_STEPS.STEP_OTP && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthStepWrapper, {
    lobName: lobname,
    icon: BOTTOM_SHEET_OTP.icon,
    heading: BOTTOM_SHEET_OTP.heading,
    subHeading: BOTTOM_SHEET_OTP.subHeading,
    closeBtn: !hideClose,
    closeModal: handleModalClose
  }, /*#__PURE__*/React.createElement(LoginWithOtp, {
    isMobileNumberDisabled: isMobileNumberDisabled
  })), confirmOtpClose && /*#__PURE__*/React.createElement(ConfirmOTPStepClose, {
    onConfirm: handleOTPStepCloseDialogConfirm
  })), activeAuthFlow === AUTH_FLOW_STEPS.STEP_POST_AUTH && /*#__PURE__*/React.createElement(UpdateProfile, {
    closeAndLogin: closeAndLogin,
    onLoginComplete: onLoginSuccess,
    showLoginToast: setShowToast,
    lobName: lobname
  }));
};

var AuthContainer = function AuthContainer(props) {
  var onClose = props.onClose,
    _props$shouldCloseOut = props.shouldCloseOutsideClick,
    shouldCloseOutsideClick = _props$shouldCloseOut === void 0 ? false : _props$shouldCloseOut,
    screenName = props.screenName,
    showAuth = props.showAuth,
    showLoginToast = props.showLoginToast,
    onLoginSuccess = props.onLoginSuccess;
  var _useAnalytics = useAnalytics(),
    adobe = _useAnalytics.adobe;
  var _useAuthFlow = useAuthFlow(function (s) {
      return {
        setActiveAuthFlow: s.setActiveAuthFlow,
        resetActiveAuthFlow: s.resetActiveAuthFlow
      };
    }, shallow),
    setActiveAuthFlow = _useAuthFlow.setActiveAuthFlow,
    resetActiveAuthFlow = _useAuthFlow.resetActiveAuthFlow;
  useEffect(function () {
    if (screenName) {
      setActiveAuthFlow(screenName);
    }
  }, [screenName]);
  if (!showAuth) {
    return null;
  }
  var handleAuthClose = function handleAuthClose() {
    var activeAuth = useAuthFlow.getState().activeAuthFlow;
    if (activeAuth === AUTH_FLOW_STEPS.STEP_POST_AUTH) {
      onLoginSuccess == null || onLoginSuccess();
    }
    clearSendOtpStore();
    resetActiveAuthFlow();
    adobe.track('ctaClick', {
      cta: {
        name: "Close Modal",
        type: "itemClick|flow:" + activeAuth,
        componentName: "GI_USER_ONBOARDING"
      }
    });
    onClose == null || onClose();
  };
  return /*#__PURE__*/React.createElement(AuthPortal, null, /*#__PURE__*/React.createElement(BottomSheet, {
    customClass: "btmSheet__animate",
    closeBottomSheet: shouldCloseOutsideClick ? handleAuthClose : undefined
  }, /*#__PURE__*/React.createElement(AuthContainer$1, null, /*#__PURE__*/React.createElement(AuthFlows, _extends({}, props, {
    onClose: handleAuthClose,
    setShowToast: showLoginToast
  })))));
};

var _templateObject;
var ProfileCompleteToast = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t&.successMsg {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tpadding: 24px 16px;\n\t\tborder-radius: 8px;\n\t\ttext-transform: capitalize;\n\t\tbackground-color: #2a2d31;\n\t}\n\n\t.successMsg.blue {\n\t\tbackground-color: #e5f2ff;\n\t}\n\n\t.successMsg__close {\n\t\tposition: absolute;\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\tright: 20px;\n\t\ttop: 20px;\n\t}\n\n\t.successMsg__title {\n\t\t", "\n\t\tcolor: #00962d;\n\t}\n\n\t.successMsg__subTitle {\n\t\t", "\n\t\tcolor: #fff;\n\t}\n\n\t&.loginSuccess {\n\t\tposition: fixed;\n\t\tleft: 50%;\n\t\tbottom: 70px;\n\t\ttransform: translateX(-50%);\n\t\tpadding: 5px 10px;\n\t\tanimation: slideUp 0.3s ease-in-out forwards;\n\t\tz-index: 1000;\n\t}\n\n\t&.loginSuccess .successMsg__title {\n\t\tfont-size: 30px;\n\t\tmargin-bottom: 5px;\n\t}\n\n\t&.loginSuccess .icSuccessBig {\n\t\tmargin-right: 40px;\n\t}\n\n\t@keyframes slideUp {\n\t\tfrom {\n\t\t\tbottom: -100px;\n\t\t\topacity: 0;\n\t\t}\n\n\t\tto {\n\t\t\tbottom: 80px;\n\t\t\topacity: 1;\n\t\t}\n\t}\n"])), headingSizes.MediumW1, textSizes.BaseW2);

var SuccessMessage = function SuccessMessage(props) {
  var width = props.width,
    theme = props.theme,
    customClass = props.customClass,
    closeToast = props.closeToast,
    _props$toastTimeout = props.toastTimeout,
    toastTimeout = _props$toastTimeout === void 0 ? 3000 : _props$toastTimeout,
    message = props.message;
  useEffect(function () {
    var timeout = setTimeout(function () {
      if (closeToast) {
        closeToast();
      }
    }, toastTimeout);
    return function () {
      if (timeout) clearTimeout(timeout);
    };
  }, []);
  return /*#__PURE__*/React.createElement(ProfileCompleteToast, {
    className: "successMsg " + (theme || '') + " " + (customClass || ''),
    style: {
      width: width || ''
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "gr-flexOne"
  }, /*#__PURE__*/React.createElement("p", {
    className: "successMsg__subTitle"
  }, message)));
};
SuccessMessage.displayName = "SuccessMessage";
var LoginToastMessage = /*#__PURE__*/React.memo(SuccessMessage);

var eventName = new Set(['HAPPY_AUTH_WEBA__UX_LOGIN_LOADED', 'HAPPY_AUTH_WEBA__UI_MOBILE_INPUT_CLICK', 'HAPPY_AUTH_WEBA__CLICK_MOBILE_CHANGE', 'HAPPY_AUTH_WEBA__UI_CLICK_SEND_OTP', 'HAPPY_AUTH_WEBA__CLICK_SEND_OTP', 'HAPPY_AUTH_WEBA__CLICK_RESEND_OTP_SMS', 'HAPPY_AUTH_WEBA__AUTO_VERIFY_SMS', 'HAPPY_AUTH_WEBA__CLICK_LOGIN_VIA_PASSWORD', 'HAPPY_AUTH_WEBA__CLICK_CLOSE_MODAL', 'HAPPY_AUTH_WEBA__CLICK_BTM_SHEET_NUDGE', 'HAPPY_AUTH_WEBA__CLICK_OTP_CONFIRM_CLOSE', 'HAPPY_AUTH_WEBA__LOAD_OTP_CONFIRM_CLOSE', 'HAPPY_AUTH_WEBA__UX_LOGIN_SUCCESS', 'HAPPY_AUTH_WEBA__CLICK_RESEND_OTP_SMS', 'HAPPY_AUTH_WEBA__UX_MOBILE_ERROR', 'HAPPY_AUTH_WEBA__CLICK_SKIP_PROFILE_UPDATE', 'HAPPY_AUTH_WEBA__CLICK_PROFILE_UPDATE', 'HAPPY_AUTH_WEBA__CLICK_LOGIN_VIA_WHATSAPP', 'growth_non_int_truecaller_skipped', 'growth_non_int_truecaller_success', 'growth_non_int_truecaller_triggered', 'growth_non_int_truecaller_enabled']);

var initGoogleAnalytics = function initGoogleAnalytics(_ref) {
  var gaInstance = _ref.gaInstance,
    lobName = _ref.lobName,
    debug = _ref.debug;
  gaInstance.initialize({
    plugin: googleTagManager(),
    globalProperties: {
      category: 'happy-header',
      device: 'desktop',
      lob: lobName
    },
    eventNames: eventName,
    debug: debug || false
  });
};

var initPdtAnalytics = function initPdtAnalytics(_ref) {
  var pdtInstance = _ref.pdtInstance,
    lobName = _ref.lobName,
    debug = _ref.debug;
  pdtInstance.initialize({
    plugin: pdtAnalytics({
      debug: false
    }),
    globalProperties: {
      eventProperties: {
        lob: lobName
      }
    },
    debug: debug || false
  });
};

var initOmnitureAnalytics = function initOmnitureAnalytics(_ref) {
  var _window$adobeDataLaye, _window$adobeDataLaye2;
  var adobeInstance = _ref.adobeInstance,
    lobName = _ref.lobName,
    debug = _ref.debug;
  var pageInfo = (_window$adobeDataLaye = window.adobeDataLayer) == null || _window$adobeDataLaye.getState == null ? void 0 : _window$adobeDataLaye.getState('page.pageInfo');
  var accountInfo = (_window$adobeDataLaye2 = window.adobeDataLayer) == null || _window$adobeDataLaye2.getState == null ? void 0 : _window$adobeDataLaye2.getState('account.accountInfo');
  adobeInstance.initialize({
    plugin: adobeAnalytics({
      page: {
        pageInfo: _extends({}, pageInfo, {
          lob: lobName
        })
      },
      account: {
        accountInfo: _extends({}, accountInfo, {
          website: 'goibibo'
        })
      }
    }, debug || false),
    debug: debug || false
  });
};

var initAnalytics = function initAnalytics(_ref) {
  var lobName = _ref.lobName,
    debug = _ref.debug;
  var gaInstance = new WebAnalytics();
  var pdtInstance = new WebAnalytics();
  var adobeInstance = new WebAnalytics();
  initGoogleAnalytics({
    gaInstance: gaInstance,
    lobName: lobName,
    debug: debug
  });
  initPdtAnalytics({
    pdtInstance: pdtInstance,
    lobName: lobName,
    debug: debug
  });
  initOmnitureAnalytics({
    adobeInstance: adobeInstance,
    lobName: lobName,
    debug: debug
  });
  return {
    gaInstance: gaInstance,
    pdtInstance: pdtInstance,
    adobeInstance: adobeInstance
  };
};

var RootHOC = function RootHOC(Component) {
  var HocComponent = function HocComponent(props) {
    var lobname = props.lobname,
      configData = props.configData;

    /** Memorize b/c we don't want to call the setData again if there in no change in configData */
    useMemo(function () {
      if (configData) setData(useConfigStore, configData);
    }, [configData]);
    var _useConfigStore = useConfigStore(function (s) {
        return {
          fetchConfigStore: s.fetch
        };
      }, shallow),
      fetchConfigStore = _useConfigStore.fetchConfigStore;
    useEffect(function () {
      fetchConfigStore({
        keys: CONFIG_KEY_MWEB_AUTH,
        lobs: 'COMMON',
        initData: configData
      });
    }, []);
    var ga;
    var pdt;
    var adobe;
    if (isOnClient) {
      var _initAnalytics = initAnalytics({
          lobName: lobname,
          debug: false
        }),
        adobeInstance = _initAnalytics.adobeInstance,
        gaInstance = _initAnalytics.gaInstance,
        pdtInstance = _initAnalytics.pdtInstance;
      ga = gaInstance;
      adobe = adobeInstance;
      pdt = pdtInstance;
    }
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: defaultTheme
    }, /*#__PURE__*/React.createElement(AnalyticsContextProvider, {
      gaInstance: ga,
      pdtInstance: pdt,
      adobeInstance: adobe
    }, /*#__PURE__*/React.createElement(Component, props)));
  };
  return HocComponent;
};

var Auth = function Auth(props) {
  var _useReducer = useReducer(loginToastReducer, loginToastInitState),
    state = _useReducer[0],
    dispatch = _useReducer[1];
  var show = state.show,
    message = state.message;
  var showLoginToast = useCallback(function (fname) {
    dispatch({
      type: 'show',
      fname: fname
    });
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AuthContainer, _extends({}, props, {
    showLoginToast: showLoginToast
  })), show && /*#__PURE__*/React.createElement(LoginToastMessage, {
    iconClass: "icSuccessBig",
    message: message,
    customClass: "loginSuccess",
    closeToast: function closeToast() {
      return dispatch({
        type: 'hide'
      });
    },
    toastTimeout: 3000
  }));
};
var MwebAuth = RootHOC(Auth);

export { CONFIG_KEY_MWEB_AUTH, MwebAuth };
